import axios from "axios";

// const instance = axios.create({
//   ...(process.env.NODE_ENV !== "production" && {
//     baseURL: "http://localhost:3001/api/v1",
//   }),
//   ...(process.env.NODE_ENV === "production" && {
//     baseURL: "https://teacher.alpaca-assessment.com/api/v1",
//   }),
// });

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const hasDedicatedSensaiApi = Boolean(process.env.REACT_APP_SENSAI_API_URL);
const sensaiInstance = axios.create({
  baseURL:
    process.env.REACT_APP_SENSAI_API_URL || process.env.REACT_APP_API_BASE_URL,
});
const sensaiEndpoint = (path = "") =>
  `${hasDedicatedSensaiApi ? "/api/sensai" : "sensai"}${path}`;

/**
 * Add JWT token to all request headers
 */
instance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("token");

    if (typeof token !== "undefined") {
      request.headers.authorization = `Bearer ${token}`;
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

sensaiInstance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("token");

    if (typeof token !== "undefined") {
      request.headers.authorization = `Bearer ${token}`;
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Authenticate user with server using email and password
 *
 * @param {*} id
 * @param {*} password
 * @returns JWT token that should be used to authenticate future requests
 */
export function login(id, password) {
  return instance
    .post("/login", { email: id, password: password })
    .then((response) => {
      return response.data;
    });
}

/**
 * Retrieve unique identifier for authenticated user
 *
 * @returns UUID for currently logged in user
 */
export function whoami() {
  return instance.get("/whoAmI").then((response) => {
    return response;
  });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getStudent(studentId) {
  return instance.get(`/students/${studentId}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getAssessment(studentid) {
  return instance.get(`/students/${studentid}/assessments`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} studentid
 * @param {*} assessmentid
 * @returns
 */
export function getTask(studentid, assessmentid) {
  return instance
    .get(`/students/${studentid}/assessments/${assessmentid}/tasks`)
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} teacherid
 * @param {*} schoolid
 * @returns
 */

export function getClasses() {
  return instance.get(`classes`).then((response) => {
    return response.data;
  });
}

export function getClassroomDashboardClasses(schoolId) {
  return instance
    .get(`/schools/${schoolId}/classrooms/classes`)
    .then((response) => {
      if (Array.isArray(response.data)) return response.data;
      return Array.isArray(response.data?.classes) ? response.data.classes : [];
    });
}

/**
 *
 * @param {*} schoolid
 * @returns
 */

export function getTeachers() {
  return instance.get(`teachers/`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getStudentsForClass(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @returns
 */
export function getAssessmentTypes() {
  return instance.get(`assessments`).then((response) => {
    return response.data;
  });
}

export function getAssessmentSteps(assessmentId) {
  return instance
    .get(`/assessments/${assessmentId}/steps`)
    .then((response) => response.data);
}

/**
 *
 * @param {*} selectStudentId
 * @param {*} selectAssessmentId
 * @param {*} selectAssessmentName
 * @returns
 */
export function assignAssessment(
  selectStudentId,
  selectAssessmentId,
  selectAssessmentName
) {
  return instance
    .post(`/students/assessments`, {
      students: selectStudentId,
      assessment: {
        id: `${selectAssessmentId}`,
        name: `${selectAssessmentName}`,
      },
      isCustom: false, // Automatically set to true for custom assessments
    })
    .then((response) => {
      return response.data;
    });
}

// export function assignAssessment(selectStudentId, selectAssessmentId, selectAssessmentName) {
//   if (!Array.isArray(selectStudentId) || !selectStudentId.every(id => typeof id === 'string')) {
//     throw new Error('selectStudentId must be an array of strings.');
//   }

//   if (!selectAssessmentId || !selectAssessmentName) {
//     throw new Error('Assessment ID and name are required.');
//   }

//   const payload = {
//     students: selectStudentId.map((id) => ({ id })), // Ensure students is an array of objects
//     assessment: {
//       id: `${selectAssessmentId}`,
//       name: `${selectAssessmentName}`,
//     },
//   };

//   console.log('Payload being sent:', payload); // Debug payload

//   return instance.post(`/students/assessments`, payload)
//     .then((response) => response.data)
//     .catch((error) => {
//       console.error('Error assigning assessment:', error.response || error);
//       throw error;
//     });
// }

/**
 *
 * @param {*} assessmentInstance
 * @returns
 */
export function unassignAssessment(assessmentInstance) {
  // console.log("selectedInstnace: ", assessmentInstance);

  return instance
    .delete(`/assessment-instances/${assessmentInstance.id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} studentId
 * @param {*} data
 * @returns
 */
export function updateStudent(studentId, data) {
  return instance.patch(`/students/${studentId}`, data).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getClassAssessments(classid) {
  return instance.get(`/classes/${classid}/assessments`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getClassResults(classid) {
  return instance.get(`/classes/${classid}/results`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {string[]} classIds - Array of class IDs to fetch assessments for.
 * @returns Promise resolving to the response data.
 */
export function getMultipleClassAssessments(classIds) {
  return instance
    .post("/classes/assessments", { classIds })
    .then((response) => {
      return response.data;
    });
}


/**
 *
 * @param {*} assessmentInstanceIDs
 * @returns
 */
export function getResultsByStudent(assessmentInstanceIDs) {
  var params = new URLSearchParams();

  assessmentInstanceIDs.forEach((id) => {
    params.append("assessmentInstanceID", id);
  });

  return instance
    .get("/assessment-instances/results/students/v2", { params: params })
    .then((response) => {
      return response.data;
    });
}

// /**
//  *
//  * @param {*} assessmentInstanceIDs
//  * @returns
//  */
// export function getResultsByStudent(assessmentInstanceIDs) {
//   var params = new URLSearchParams();

//   assessmentInstanceIDs.forEach((id) => {
//     params.append("assessmentInstanceID", id);
//   });

//   return instance
//     .get("/assessment-instances/results/students", { params: params })
//     .then((response) => {
//       return response.data;
//     });
// }

// /**
//  *
//  * @param {*} assessmentInstanceID
//  * @returns
//  */
// export function getResultsByStudent(assessmentInstanceID) {
//   return instance
//     .get("/assessment-instances/results/students", {
//       params: {
//         assessmentInstanceID: `${assessmentInstanceID}`,
//       },
//     })
//     .then((response) => {
//       return response.data;
//     });
// }

/**
 * Fetches all assessment results for a school based on its rollnumber.
 *
 * @param {string} rollnumber - The rollnumber of the school.
 * @returns {Promise} - A promise resolving to the assessment results data.
 */
export function getAllAssessmentInstances(rollnumber) {
  return instance
    .get(`/schools/rollnumber/${rollnumber}/assessment-results`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching assessment results for school:", error);
      throw error;
    });
}

/**
 * Fetch student results using a POST request.
 * @param {Array} assessmentInstanceIDs - An array of assessment instance IDs.
 * @returns Promise resolving to the response data.
 */
export function postResultsByStudent(assessmentInstanceIDs) {
  return instance
    .post("/assessment-instances/results/students", assessmentInstanceIDs)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

/**
 * Fetch student results using a POST request.
 * @param {Array} assessmentInstanceIDs - An array of assessment instance IDs.
 * @returns Promise resolving to the response data.
 */
export function getStudentResults(assessmentInstanceIDs) {
  return instance
    .post("/assessment-instances/results/students", assessmentInstanceIDs)
    .then((response) => {
      console.log("response:", response);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function getClass(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function editClass(classid, nameOfClass, gradeLevel) {
  return instance
    .patch(`classes/${classid}`, {
      name: `${nameOfClass}`,
      grade_level: `${gradeLevel}`,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function shareClass(classid, teacherid, isSpecialCondition = false) {
  return instance
    .patch(`classes/${classid}/share`, {
      op: "add",
      teacherid: `${teacherid}`,
      isSpecialCondition,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Mark a class access request as approved.
 * @param {string} requestId
 * @returns
 */
export function approveClassAccessRequest(requestId) {
  return instance
    .post(`/class-access-requests/${encodeURIComponent(requestId)}/approve`)
    .then((response) => {
      return response.data;
    });
}
/**
 *
 * @param {*} classid
 * @returns
 */

export function unShareClass(classid, teacherid) {
  return instance
    .patch(`classes/${classid}/share`, {
      op: "remove",
      teacherid: `${teacherid}`,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function addStudents(classid, name) {
  if (name?.length > 0) {
    return instance
      .post(`classes/${classid}/students`, name)
      .then((response) => {
        return response.data;
      });
  } else {
    return null;
  }
}

/**
 *
 * @param {*} classid
 * @returns
 */

export function getStudents(classid) {
  return instance.get(`classes/${classid}`).then((response) => {
    return response.data;
  });
}

export function getCountryGrades(countryid) {
  return instance.get(`/grades/${countryid}`).then((response) => {
    return response.data;
  });
}

// /**
//  *
//  * @param {*} name
//  * @param {*} grade
//  * @param {*} grade1
//  * @param {*} grade2
//  * @param {*} trialClass
//  * @param {*} specialEdClass
//  * @returns
//  */
// export function createClass(
//   name,
//   grade,
//   grade1,
//   grade2,
//   trialClass,
//   specialEdClass, // Should be boolean
//   classOwner,
//   setClass
// ) {
//   return instance
//     .post(`/classes`, {
//       name: name,
//       grade_level: grade,
//       grade_level1: grade1,
//       grade_level2: grade2,
//       trial_class: trialClass,
//       specialed_class: specialEdClass, // Ensure this is a boolean
//       classOwnerId: classOwner,
//       set_class: setClass,
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error creating class:", error.message);
//       if (error.response && error.response.data) {
//         console.error("Error details:", error.response.data);
//       }
//       throw error; // Rethrow the error to be handled in the calling code
//     });
// }


// /**
//  * Create a new class
//  * @param {string} name - Class name
//  * @param {string} grade - Primary grade level
//  * @param {boolean} grade1 - Grade level 1 flag
//  * @param {boolean} grade2 - Grade level 2 flag
//  * @param {boolean} trialClass - Whether this is a trial class
//  * @param {boolean} specialEdClass - Whether this is a special education class
//  * @param {string} classOwner - Class owner identifier
//  * @param {boolean} setClass - Set class flag
//  * @returns {Promise} - Promise resolving to the created class data
//  */
// export function createClass(
//   name,
//   grade,
//   grade1,
//   grade2,
//   grade3,
//   trialClass,
//   specialEdClass,
//   classOwner,
//   setClass
// ) {
//   return instance
//     .post(`/classes`, {
//       name: name,
//       grade_level: grade,
//       grade_level1: grade1,
//       grade_level2: grade2,
//       grade_level3: grade3,
//       trial_class: trialClass,
//       specialed_class: specialEdClass,
//       classOwnerId: classOwner,
//       set_class: setClass,
//       // snapshot and academicYear are set automatically in backend
//       // teacherId and schoolid are set automatically in backend
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error creating class:", error.message);
//       if (error.response && error.response.data) {
//         console.error("Error details:", error.response.data);
//       }
//       throw error;
//     });
// }

/**
 * Create a new class
 * @param {string} name - Class name
 * @param {string} grade - Primary grade level
 * @param {boolean} grade1 - Grade level 1 flag
 * @param {boolean} grade2 - Grade level 2 flag
 * @param {boolean} grade3 - Grade level 3 flag
 * @param {boolean} trialClass - Whether this is a trial class
 * @param {boolean} specialEdClass - Whether this is a special education class
 * @param {string} classOwner - Class owner identifier
 * @param {boolean} setClass - Set class flag
 * @param {string} academicYear - Optional academic year (e.g., "25-26"). If not provided, calculated automatically
 * @param {string} progressionKey - Optional durable progression key for handover-created classes
 * @returns {Promise} - Promise resolving to the created class data
 */
export function createClass(
  name,
  grade,
  grade1,
  grade2,
  grade3,
  trialClass,
  specialEdClass,
  classOwner,
  setClass,
  academicYear = null,
  progressionKey = null
) {
  const requestBody = {
    name: name,
    grade_level: grade,
    grade_level1: grade1,
    grade_level2: grade2,
    grade_level3: grade3,
    trial_class: trialClass,
    specialed_class: specialEdClass,
    classOwnerId: classOwner,
    set_class: setClass,
  };

  // Only include academicYear if provided
  if (academicYear) {
    requestBody.academicYear = academicYear;
  }
  if (progressionKey) {
    const progressionGrade = progressionKey.match(/^grade(\d+)$/)?.[1];
    if (progressionGrade) requestBody[`grade_level${progressionGrade}`] = true;
  }

  return instance
    .post(`/classes`, requestBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating class:", error.message);
      if (error.response && error.response.data) {
        console.error("Error details:", error.response.data);
      }
      throw error;
    });
}

/**
 * Deletes the specified class
 * Current API implemenation (Sept 2022) does not enforce relational integrity constraints
 * so deleting a class will not delete any students that are associated with the class.
 * However, the link (relationship) between a student and a school will be lost since:
 *
 * School -> Teacher -> Class -> Student -> Assessment
 *
 * @param {*} classid The UUID of the class to delete.
 * @returns true if class deleted successfully (if API responds with a 204 response code)
 */
export function deleteClass(classid) {
  return instance.delete(`/classes/${classid}`).then((response) => {
    let success = false;

    if (response.status === 204) {
      success = true;
    }
    return success;
  });
}

/**
 * Deletes the specified student
 * Current API implemenation (Sept 2022) does not enforce relational integrity constraints
 * so deleting a student will not delete any assessments that are associated with the student.
 * However, the link (relationship) between an assessment and a school/country will be lost since:
 *
 * School -> Teacher -> Class -> Student -> Assessment
 *
/**
 * @param {string} studentid - The UUID of the student to delete.
 * @returns {Promise<boolean>} - true if the student was deleted successfully (if API responds with a 204 response code), false otherwise.
 */
export function deleteStudent(studentId) {
  return instance
    .delete(`/students/${studentId}`)
    .then((response) => {
      console.log(response);
      if (response.status === 204) {
        return true; // Explicitly return true on success
      } else {
        console.error("Unexpected response status:", response.status);
        return false; // Return false if the status is not what is expected
      }
    })
    .catch((error) => {
      // Improved error logging
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error deleting student:", error.message);
        console.error("Status code:", error.response.status);
        console.error("Error data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error(
          "No response received when deleting student:",
          error.request
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error(
          "Error setting up request to delete student:",
          error.message
        );
      }

      return false; // Return false on error
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getQR(classid) {
  return instance.get(`classes/${classid}/qr`).then((response) => {
    return Array.isArray(response.data) ? response.data : [];
  });
}


/**
 *
 * @param {*} studentid
 * @returns
 */
export function getIndividualStudentResults(studentid) {
  return instance
    .get(`students/${studentid}/assessments/results/v2`)
    .then((response) => {
      // console.log(response.data)
      return response.data;
    });
}


// /**
//  *
//  * @param {*} studentid
//  * @returns
//  */
// export function getIndividualStudentResults(studentid) {
//   return instance
//     .get(`students/${studentid}/assessments/results`)
//     .then((response) => {
//       // console.log(response.data)
//       return response.data;
//     });
// }

/**
 * Post student answers for a specific task to the server
 *
 * @param {*} studentid
 * @param {*} assessmentid
 * @param {*} taskid
 * @param {*} results
 */
export function saveTaskAnswers(studentid, assessmentid, taskid, results) {
  return instance
    .post(
      `/students/${studentid}/assessments/${assessmentid}/tasks/${taskid}/answers`,
      results
    )
    .then((response) => response.data);
}

/**
 * Post email to request password reset
 *
 * @param {*} email
 *
 */
export function requestPasswordReset(email) {
  instance.post(`/user/password/request`, { email });
}

/**
 * Post new password with token
 * @param {string} password The new password to set.
 * @param {string} token The reset token linked to the user's password reset request.
 */
export function updatePassword(password, token) {
  console.log(password);
  console.log(token);
  return instance
    .post(`/user/password/resetPassword/${token}`, { password })
    .then((response) => {
      console.log("Password update successful:", response.data);
      return { success: true, message: "Password updated successfully." };
    })
    .catch((error) => {
      console.error("Error updating password:", error.response);
      return {
        success: false,
        message: "Failed to update password. Please try again.",
      };
    });
}

/**
 * Fetches all assessment results for a student based on their student ID.
 *
 * @param {string} studentid - The ID of the student.
 * @returns {Promise} - A promise resolving to the assessment results data.
 */
export function getAllStudentResults(studentid) {
  return instance
    .get(`/students/${studentid}/assessments/results`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching assessment results for student:", error);
      throw error;
    });
}

// export function updatePassword(password, token) {
//   return instance.post(`/user/password/resetPassword/${token}`, { password })
//     .then(response => {
//       console.log('Password update successful:', response.data);
//       return { success: true, message: 'Password updated successfully.' };
//     })
//     .catch(error => {
//       console.error('Error updating password:', error.response);
//       if (error.response) {
//         // Handle different cases based on the status code
//         const status = error.response.status;
//         if (status === 404) {
//           return { success: false, message: 'Token not valid or expired.' };
//         } else if (status === 422) {
//           return { success: false, message: 'Validation failed. Check the provided data.' };
//         }
//       }
//       return { success: false, message: 'Failed to update password. Please try again.' };
//     });
// }

/**
 * Update teacher's profile details
 *
 * @param {string} teacherId - The ID of the teacher to update.
 * @param {object} data - The data to update (name, additionalRoles, mobileNumber, roleids).
 * @returns The updated teacher data.
 */
export function updateTeacherProfile(schoolId, teacherId, data) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update teacher's profile details including email
 *
 * @param {string} schoolId - The ID of the school the teacher belongs to.
 * @param {string} teacherId - The ID of the teacher to update.
 * @param {object} data - The data to update (name, additionalRoles, mobileNumber, email).
 * @param {string} [data.name] - Teacher's name.
 * @param {string[]} [data.additionalRoles] - Array of additional roles.
 * @param {string} [data.mobileNumber] - Teacher's mobile number.
 * @param {string} [data.email] - Teacher's email address.
 * @returns {Promise} The updated teacher data.
 */
export function updateTeacherProfileWithEmail(schoolId, teacherId, data) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/profile`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Log a teacher update for audit purposes
 * 
 * @param {string} teacherId - The ID of the teacher that was updated
 * @param {object} oldValues - Object containing the previous values of changed fields
 * @param {object} newValues - Object containing the new values of changed fields
 * @param {string} [updatedBy] - Optional ID of the user who made the update
 * @returns {Promise} Promise that resolves to the created log entry
 */
export function logTeacherUpdate(teacherid, oldValues, newValues, updatedBy) {
  return instance
    .post('/teacher-update-logs', {
      teacherid,
      old_values: oldValues,
      new_values: newValues,
      updated_by: updatedBy || "NA", // Use null if updatedBy is not provided
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Post new user data
 *
 * @param {*} user
 *
 */
export function signupTeacher(user) {
  const { email, password, school } = user;

  // console.log(user)

  return new Promise((resolve, reject) => {
    instance
      .post(`/signup`, {
        email,
        password,
        roles: ["teacher"],
        stakeholderType: "Teacher",
      })
      .then((userData) => {
        login(email, password)
          .then((loginData) => {
            localStorage.setItem("token", loginData.token);
            instance
              .post(`/schools/${school}/teachers`, {
                name: user.name,
                userId: userData.data.id,
                classroomTeacher: true,
                additionalRoles: user.roles,
                mobileNumber: user.mobileNumber,
                language: "en",
              })
              .then((res) => {
                resolve(true);
              })
              .catch((error) => {
                // console.log("Error creating new teacher", error.response);
                reject(false);
              });
          })
          .catch((error) => {
            // console.log("Error logging in new user", error.response);
            reject(false);
          });
      })
      .catch((error) => {
        // console.log("Error creating new user", error.response);
        reject(false);
      });
  });
}

/**
 * Get all schools
 *
 */
export function getSchools() {
  return instance.get("/schools");
}

/**
 * Get all schools
 *
 */
export function getIndividualSchool(schoolid) {
  return instance.get(`/schools/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Get all rolescd
 *
 */
export function getRoles() {
  return instance.get("/roles");
}

export function getPendingTeacher(pendingteacherid) {
  return instance
    .get(`/pending-teachers/${pendingteacherid}`)
    .then((response) => {
      //  console.log(response.data)
      return response.data;
    });
}

export function deletePendingTeacher(pendingteacherid) {
  return instance
    .delete(`/pending-teachers/${pendingteacherid}`)
    .then((response) => {
      // console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting pending teacher:", error);
      throw error;
    });
}

/**
 *
 * @param {*} classid
 * @returns
 */
export function getPendingTeacherBySchoolId(schoolid) {
  return instance
    .get(`/pending-teachers/school/${schoolid}`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching pending teachers:", error);
      // Depending on your setup, you might want to throw an error or return a default value
      throw error;
    });
}

/**
 * Function to add additional colleagues as pending teachers.
 * @param {string} schoolId - The ID of the school the colleagues are associated with.
 * @param {string} rollnumber - The roll number to be used for each colleague.
 * @param {Array} colleagues - Array of objects, each containing the name, email, and optional sharedClassId of a colleague.
 * @param {string} teacherName - The name of the teacher adding the colleagues.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export function addAdditionalColleagues(
  schoolId,
  rollnumber,
  colleagues,
  teacherName,
  countryId
) {
  console.log(schoolId);
  console.log(rollnumber); // Ensure this logs the expected value
  console.log(colleagues);
  console.log(teacherName);
  console.log(countryId);

  if (!colleagues || colleagues.length === 0) {
    console.warn("No colleagues provided to add.");
    return Promise.reject("No colleagues provided to add.");
  }

  // Use the rollnumber parameter for each user, including the optional sharedClassId
  const users = colleagues.map(
    ({ firstName, lastName, email, sharedClassId }) => ({
      firstName,
      lastName,
      email,
      rollnumber, // This now correctly uses the rollnumber passed to the function
      roles: "Teacher", // Assuming a default role for simplicity.
      sharedClassId, // Include the optional sharedClassId
    })
  );

  const payload = {
    users,
    schoolId,
    teacherName,
    countryId,
  };

  console.log(users.sharedClassId, "PAYLOAD");

  return instance
    .post("/pending-teachers", payload)
    .then((response) => {
      console.log(response);

      return response.data;
    })
    .catch((error) => {
      console.error("Error adding additional colleagues:", error);
      throw error;
    });
}

/**
 * Check if the colleague already exists in the pending teachers' table.
 *
 * @param {string} email - The email of the colleague to check.
 * @returns {Promise<boolean>} - True if the colleague exists, false otherwise.
 */
export function checkColleagueExists(email) {
  return instance
    .get("/pending-teachers/check", { params: { email } })
    .then((response) => response.data.exists)
    .catch((error) => {
      console.error("Error checking if colleague exists:", error);
      throw error;
    });
}

/**
 * Function to submit multiple referrals.
 * @param {string} referrerId - The ID of the teacher making the referrals.
 * @param {Array} referrals - Array of objects, each containing the email (and possibly name) of the referred teacher.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export function submitMultipleReferrals(teacherId, referrals, teacherADetails) {
  if (!referrals || referrals.length === 0) {
    console.warn("No referrals provided.");
    return Promise.reject("No referrals provided.");
  }

  const referralEntries = referrals.map(({ email, firstName, lastName }) => ({
    teacherId,
    referredEmail: email,
    firstName,
    lastName,
    referralCode: "DefaultCode",
    status: "Pending",
    inPendingTeacherTable: false,
    uniqueUrlSent: false,
    createDate: new Date().toISOString(),
    // Including TeacherA's details
    referrerName: teacherADetails.fullName,
    referrerEmail: teacherADetails.email,
  }));

  console.log(referralEntries);

  return instance
    .post("/referrals/batch", referralEntries)
    .then((response) => {
      console.log("Submission successful", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error submitting multiple referrals:", error);
      throw error;
    });
}

/**
 * Fetch report options based on the type of report.
 * @param {boolean} isSenco - If true, fetch options for SENCO, false for JISI.
 * @returns {Promise}
 */
export function getReportOptions(isSenco) {
  const reportTypeParam = isSenco ? "sencoreport=true" : "jisireport=true";
  return instance
    .get(`/report-options?${reportTypeParam}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching report options:", error);
      throw error;
    });
}

/**
 * Upserts JISI report based on the provided data.
 * @param {Object} reportData - The JSON data for the JISI report.
 * @returns {Promise}
 */
export function upsertJiSiReport(reportData) {
  return instance
    .post("/ji-si-reports/upsert", reportData)
    .then((response) => {
      console.log("Upsert JISI Report Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error upserting JISI Report:", error);
      throw error;
    });
}

/**
 * Fetches a JiSiReport based on student ID.
 * @param {string} studentId - The ID of the student to fetch the report for.
 * @returns {Promise}
 */
export function getJiSiReportByStudentId(studentId) {
  return instance
    .get(`/ji-si-reports/by-student/${studentId}`)
    .then((response) => {
      // console.log("Fetched JiSi Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching JiSi Report by student ID:", error);
      throw error;
    });
}

/**
 * Fetches a JiSiReport based on class ID.
 * @param {string} classId - The ID of the class to fetch the report for.
 * @returns {Promise}
 */
export function getJiSiReportByClassId(classId) {
  return instance
    .get(`/ji-si-reports/by-class/${classId}`)
    .then((response) => {
      // Logging can be uncommented for debugging purposes or removed after testing
      // console.log("Fetched JiSi Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching JiSi Report by class ID:", error);
      // Propagating error up to the caller allows for more flexible error handling
      throw error;
    });
}

/**
 * Upserts SENCO report based on the provided data.
 * @param {Object} reportData - The JSON data for the SENCO report.
 * @returns {Promise}
 */
export function upsertSencoReport(reportData) {
  return instance
    .post("/senco-reports/upsert", reportData)
    .then((response) => {
      console.log("Upsert SENCO Report Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error upserting SENCO Report:", error);
      throw error;
    });
}

/**
 * Fetches a SencoReport based on student ID.
 * @param {string} studentId - The ID of the student to fetch the report for.
 * @returns {Promise}
 */
export function getSencoReportByStudentId(studentId) {
  return instance
    .get(`/senco-reports/by-student/${studentId}`)
    .then((response) => {
      console.log("Fetched SENCO Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching SENCO Report by student ID:", error);
      throw error;
    });
}

/**
 * Fetches a SencoReport based on class ID.
 * @param {string} classId - The ID of the class to fetch the report for.
 * @returns {Promise}
 */
export function getSencoReportByClassId(classId) {
  return instance
    .get(`/senco-reports/by-class/${classId}`)
    .then((response) => {
      // Logging can be uncommented for debugging purposes or removed after testing
      // console.log("Fetched Senco Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching Senco Report by class ID:", error);
      // Propagating error up to the caller allows for more flexible error handling
      throw error;
    });
}

/**
 * Fetches a SencoReport based on School ID.
 * @param {string} schoolid - The ID of the school to fetch the report for.
 * @returns {Promise}
 */
export function getSencoReportBySchoolId(schoolid) {
  return instance
    .get(`/senco-reports/by-school/${schoolid}`)
    .then((response) => {
      // Logging can be uncommented for debugging purposes or removed after testing
      // console.log("Fetched Senco Report:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching Senco Report by class ID:", error);
      // Propagating error up to the caller allows for more flexible error handling
      throw error;
    });
}

/**
 * Resend an invitation to a teacher using a POST request.
 * @param {string} teacherId - The ID of the teacher to whom the invite should be resent.
 * @returns {Promise} - A promise resolving to the response data.
 */
export function resendTeacherInvite(teacherId) {
  return instance
    .post(`/pending-teachers/remind/${teacherId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error resending invite:", error);
      throw error;
    });
}

/**
 * Add Alpaca Lead role to a teacher
 */
export function addAlpacaLeadRole(schoolId, teacherId) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/add-alpaca-lead`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error adding Alpaca Lead role:", error);
      throw error;
    });
}

/**
 * Remove Alpaca Lead role from a teacher
 */
export function removeAlpacaLeadRole(schoolId, teacherId) {
  return instance
    .patch(`/schools/${schoolId}/teachers/${teacherId}/remove-alpaca-lead`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error removing Alpaca Lead role:", error);
      throw error;
    });
}

/**
 * Function to update the class ID of a student
 * @param {string} studentId - The ID of the student to update
 * @param {string} newClassId - The new class ID to assign to the student
 * @returns {Promise} - A promise resolving to the response data
 */
export function updateStudentClassId(studentId, newClassId) {
  return instance.patch(`/students/${studentId}/class-id`, {
    classId: newClassId,
  });
}

/**
 * Fetches AnswerDeletionReason options.
 * @returns {Promise}
 */
export function getAnswerDeletionReasonOptions() {
  return instance
    .get("answer-deletion-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching AnswerDeletionReason options:", error);
      throw error;
    });
}

/**
 * Fetches ChangeClassReason options.
 * @returns {Promise}
 */
export function getChangeClassReasonOptions() {
  return instance
    .get("/change-class-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching ChangeClassReason options:", error);
      throw error;
    });
}

/**
 * Fetches Change Alpaca Lead options.
 * @returns {Promise}
 */
export function getAlpacaLeadChangeReasonOptions() {
  return instance
    .get("/alpaca-lead-change-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching AlpacaLeadChange options:", error);
      throw error;
    });
}

/**
 * Deletes answers with the provided deletion data.
 * @param {Object} deletionData - The deletion data object
 * @param {string[]} deletionData.answerIds - Array of answer IDs to delete
 * @param {string} deletionData.teacherId - ID of the teacher performing deletion
 * @param {string} deletionData.deletionReasonId - ID of the deletion reason
 * @param {string} [deletionData.deletionReason] - Optional additional deletion reason text
 * @returns {Promise<boolean>} - true if successful (204 response), false otherwise
 */
export function deleteAnswers(deletionData) {
  return instance
    .delete("/answers", {
      data: {
        answerIds: deletionData.answerIds,
        teacherId: deletionData.teacherId,
        deletionReasonId: deletionData.deletionReasonId,
        deletionReason: deletionData.deletionReason
      }
    })
    .then((response) => {
      console.log(response);
      if (response.status === 204) {
        return true;
      } else {
        console.error("Unexpected response status:", response.status);
        return false;
      }
    })
    .catch((error) => {
      if (error.response) {
        console.error("Error deleting answers:", error.message);
        console.error("Status code:", error.response.status);
        console.error("Error data:", error.response.data);
      } else if (error.request) {
        console.error("No response received when deleting answers:", error.request);
      } else {
        console.error("Error setting up request to delete answers:", error.message);
      }
      return false;
    });
}

// /**
//  * Updates the answer deletion reason table.
//  * @param {string} answerId - The UUID of the answer.
//  * @param {string} reasonId - The ID of the deletion reason.
//  * @param {string} deletionReason - The textual reason for deletion.
//  * @returns {Promise<boolean>} - true if the deletion reason was updated successfully, false otherwise.
//  */
// export function updateAnswerDeletionReason(answerId, reasonId, deletionReason, teacherId) {
//   return instance
//     .post(`/answer-deletion-reasons`, {
//       answerid: answerId,
//       answerdeletionreasonsid: reasonId,
//       deletionreason: deletionReason,
//       teacherid: teacherId,

//     })
//     .then((response) => {
//       console.log(response);
//       return response.status === 200;
//     })
//     .catch((error) => {
//       console.error("Error updating answer deletion reason:", error);
//       return false;
//     });
// }

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} answerDeletedData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateAnswerDeletionReason(answerDeletedData) {
  return instance
    .post("/answers-deleted", answerDeletedData)
    .then((response) => {
      console.log("Answer Deleted Record Creation Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Answer Deleted Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} classChangedData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateClassChangeReason(classChangedData) {
  return instance
    .post("/class-change-histories", classChangedData)
    .then((response) => {
      console.log("Class Changed Record Creation Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Class Changed Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates an AnswerDeleted record based on the provided data.
 * @param {Object} alpacaLeadChangeData - The JSON data for the AnswerDeleted record.
 * @returns {Promise}
 */
export function updateAlpacaLeadChangeReason(alpacaLeadChangeData) {
  return instance
    .post("/alpaca-lead-histories", alpacaLeadChangeData)
    .then((response) => {
      console.log(
        "Alpaca Lead Changed Record Creation Success:",
        response.data
      );
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Alpaca Lead Changed Record:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Error request data:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
      }
      throw error;
    });
}

/**
 * Creates a SpecialEdStudent based on the provided data.
 * @param {Object} studentData - The JSON data for the SpecialEdStudent.
 * @returns {Promise}
 */
export function createSpecialEdStudent(studentData) {
  return instance
    .post("/special-ed-students", studentData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating SpecialEdStudent:", error);
      throw error;
    });
}

/**
 *
 * @param {*} schoolid
 * @returns
 */
export function getAllowedProperties(schoolid) {
  return instance.get(`/schools/${schoolid}/config`).then((response) => {
    return response.data;
  });
}

/**
 * Fetches all ClassOwnerChangeReason entries.
 *
 * @returns {Promise<Array>} - A promise that resolves to an array of ClassOwnerChangeReason data.
 */
export function getClassOwnerChangeReasons() {
  return instance
    .get("/class-owner-change-reasons")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching ClassOwnerChangeReasons:", error);
      throw error;
    });
}

/**
 * Updates the classOwnerId of a class by ID.
 *
 * @param {string} classId - The ID of the class to update.
 * @param {string} classOwnerId - The new classOwnerId value.
 * @returns {Promise<object>} - A promise that resolves to the updated class data.
 */
export function updateClassOwnerId(classId, classOwnerId) {
  // Prepare the data object to send in the request body
  const data = {
    classOwnerId: classOwnerId,
  };

  return instance
    .patch(`/classes/${classId}`, data)
    .then((response) => {
      // Return the updated class data from the response
      return response.data;
    })
    .catch((error) => {
      // Handle errors if the request fails
      console.error("Error updating classOwnerId:", error);
      throw error; // Re-throw the error to be handled by the caller
    });
}

/**
 * Creates a new ClassOwnershipHistory entry.
 *
 * @param {Object} classOwnershipHistoryData - The data for the new ClassOwnershipHistory entry.
 * @param {string} classOwnershipHistoryData.teacherId - The ID of the teacher associated with the ownership change.
 * @param {string} classOwnershipHistoryData.oldClassOwner - The ID of the previous class owner.
 * @param {string} classOwnershipHistoryData.newClassOwner - The ID of the new class owner.
 * @param {string} classOwnershipHistoryData.reasonForChangeId - The ID of the reason for the ownership change.
 * @param {string} [classOwnershipHistoryData.classownerchangereason] - A string describing the reason for the change.
 * @param {Date} [classOwnershipHistoryData.dateChanged] - The date of the ownership change. Defaults to the current date.
 * @returns {Promise<Object>} - A promise that resolves to the newly created ClassOwnershipHistory data.
 */
export function createClassOwnershipHistory(classOwnershipHistoryData) {
  return instance
    .post("/class-ownership-histories", classOwnershipHistoryData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating ClassOwnershipHistory:", error);
      throw error;
    });
}

/**
 * Updates the grade levels of a class.
 *
 * This function sets `grade_level1` to `false` and `grade_level2` to `true` for the specified class.
 *
 * @param {string} classId - The ID of the class to update.
 * @returns {Promise<void>} - A promise that resolves when the update is complete.
 */
export function updateGradeLevels(classId) {
  return axios
    .patch(`/classes/${classId}/update-grade-levels`)
    .then((response) => {
      console.log("Grade levels updated successfully");
    })
    .catch((error) => {
      console.error("Error updating grade levels:", error);
      throw error;
    });
}

/**
 * Creates a LastLogin based on the provided data.
 * @param {Object} studentData - The JSON data for the LastLogin.
 * @returns {Promise}
 */
export function postLastLogin(teacherid) {
  return instance
    .post("/lastloggedin", { teacherid })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Logging Last Login:", error);
      throw error;
    });
}

/**
 * Fetches the most recent LastLogin entry for the given teacherid.
 * @param {string} teacherid - The teacher's ID.
 * @returns {Promise}
 */
export function getLastLogin(teacherid) {
  return instance
    .get(`/lastloggedin/${teacherid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching last login:", error);
      throw error;
    });
}

// export function getAllStudentsResultsPerAssessment(
//   studentIds,
//   assessmentInstanceIds
// ) {
//   // Log the data being passed to the function
//   console.log("Preparing to send request with the following data:");
//   console.log("Student IDs:", studentIds);
//   console.log("Assessment Instance IDs:", assessmentInstanceIds);
//   console.log("FIRE");

//   return instance
//     .post("/students/assessments/results/v2", {
//       studentIds: studentIds,
//       assessmentInstanceIds: assessmentInstanceIds,
//     })
//     .then((response) => {
//       // Log the response data
//       console.log("Received response:", response.data);
//       return response.data;
//     })
//     .catch((error) => {
//       // Handle any errors here
//       console.error("Error fetching student results:", error);
//       throw error; // or return an error message, depending on your error handling strategy
//     });
// }

export function getAllStudentsResultsPerAssessment(
  studentIds,
  assessmentInstanceIds
) {
  // Log the data being passed to the function
  console.log("Preparing to send request with the following data:");
  console.log("Student IDs:", studentIds);
  console.log("Assessment Instance IDs:", assessmentInstanceIds);
  console.log("FIRE");

  return instance
    .post("/students/assessments/results/v3", {
      studentIds: studentIds,
      assessmentInstanceIds: assessmentInstanceIds,
    })
    .then((response) => {
      // Log the response data
      console.log("Received response:", response.data);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

/**
 * Creates a new trialist entry.
 * @param {Object} trialistData - The data for the new trialist.
 * @returns {Promise}
 */
export function createTrialist(trialistData) {
  return instance
    .post("/trialists", trialistData)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating trialist:", error);
      throw error;
    });
}

/**
 * Creates a trialist entry for a specific school and trial.
 * This function sends a POST request to the backend API, creating a trialist.
 *
 * @param {string} schoolid - The unique identifier for the school.
 * @param {string} trialid - The unique identifier for the trial.
 * @returns {Promise<Object>} A promise that resolves with the data of the newly created trialist.
 */
export function createTrialistBySchoolid(schoolid, trialid) {
  return instance
    .post(`/trialists/${schoolid}/${trialid}`)
    .then((response) => {
      // Successfully created the trialist
      return response.data;
    })
    .catch((error) => {
      // Handle different types of errors
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Backend returned status code:", error.response.status);
        console.error("Error data:", error.response.data);
        throw new Error(
          `Backend error: ${error.response.data.message || "Unknown error"}`
        );
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        throw new Error("No response from backend");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
        throw new Error(error.message);
      }
    });
}

/**
 * Fetches trialist entries for a specific school.
 * @param {string} schoolid - The ID of the school.
 * @returns {Promise}
 */
export function getTrialistsBySchool(schoolid) {
  return instance
    .get(`/trialists/school/${schoolid}`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching trialists by school ID:", error);
      throw error;
    });
}

/**
 * Updates the start date for a trialist and sets started to true.
 * @param {string} schoolid - The school ID.
 * @param {string} start_date - The start date in ISO format.
 * @returns {Promise}
 */
export function updateTrialistStartDate(schoolid, start_date) {
  return instance
    .patch(`/trialists/school/${schoolid}/start`, { start_date })
    .catch((error) => {
      console.error("Error updating trialist start date:", error);
      throw error;
    });
}

/**
 * Updates the end date for a trialist.
 * @param {string} schoolid - The school ID.
 * @param {string} end_date - The end date in ISO format.
 * @returns {Promise}
 */
export function updateTrialistEndDate(schoolid, end_date) {
  return instance
    .patch(`/trialists/school/${schoolid}/end`, { end_date })
    .catch((error) => {
      console.error("Error updating trialist end date:", error);
      throw error;
    });
}

/**
 * Applies an extension to a trialist, setting extension_applied to true and updating the end date.
 * @param {string} schoolid - The school ID.
 * @returns {Promise}
 */
export function applyTrialistExtension(schoolid) {
  return instance
    .patch(`/trialists/school/${schoolid}/extension`, {
      extension_applied: true,
    })
    .catch((error) => {
      console.error("Error applying trialist extension:", error);
      throw error;
    });
}

/**
 * Marks a trialist as completed.
 * @param {string} schoolid - The school ID.
 * @param {boolean} completed - Completion status.
 * @returns {Promise}
 */
export function markTrialistCompleted(schoolid, completed = true) {
  return instance
    .patch(`/trialists/school/${schoolid}/completed`, { completed })
    .catch((error) => {
      console.error("Error marking trialist as completed:", error);
      throw error;
    });
}

/**
 * Marks a trialist as expired.
 * @param {string} schoolid - The school ID.
 * @param {boolean} expired - Expired status.
 * @returns {Promise}
 */
export function markTrialistExpired(schoolid, expired = true) {
  return instance
    .patch(`/trialists/school/${schoolid}/expired`, { expired })
    .catch((error) => {
      console.error("Error marking trialist as expired:", error);
      throw error;
    });
}

/**
 * Marks a trialist as purchased.
 * @param {string} schoolid - The school ID.
 * @param {boolean} purchased - Purchased status.
 * @returns {Promise}
 */
export function markTrialistPurchased(schoolid, purchased = true) {
  return instance
    .patch(`/trialists/school/${schoolid}/purchased`, { purchased })
    .catch((error) => {
      console.error("Error marking trialist as purchased:", error);
      throw error;
    });
}

/**
 * Fetches a trialist entry by ID.
 * @param {string} id - The ID of the trialist.
 * @returns {Promise}
 */
export function getTrialistById(id) {
  return instance
    .get(`/trialists/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching trialist by ID:", error);
      throw error;
    });
}

/**
 * Updates a trialist entry by ID.
 * @param {string} id - The ID of the trialist.
 * @param {Object} updateData - The data to update.
 * @returns {Promise}
 */
export function updateTrialistById(id, updateData) {
  return instance.patch(`/trialists/${id}`, updateData).catch((error) => {
    console.error("Error updating trialist by ID:", error);
    throw error;
  });
}

/**
 * Updates the user activity for a specific teacher.
 * @param {string} teacherid - The teacher's ID.
 * @param {string} activity - The activity type to update (e.g., "class_created", "students_added").
 * @returns {Promise}
 */
export function updateUserActivity(teacherid, activity) {
  return instance
    .post("/user-activity", { teacherid, activity })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating user activity:", error);
      throw error;
    });
}

export function sendPurchaseEmail(email, teacherName, purchaseFormUrl) {
  return instance
    .post("/send-purchase-email", { email, teacherName, purchaseFormUrl }) // POST request with data in the body
    .then((response) => {
      console.log("Email sent successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error sending purchase email:", error);
      throw error;
    });
}

// SENCO View Calls

/**
 * Fetch assessments for multiple classes
 * @param {string[]} classIds - Array of class IDs
 * @returns {Promise<any[]>} - Promise resolving to the assessment data for each class
 */
export function getClassAssessmentsForMultipleClasses(classIds) {
  return instance
    .post("/classes/assessments", { classIds })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching class assessments:", error);
      throw error;
    });
}

/**
 * Fetch school assessments for a half-open date range.
 * @param {string} schoolId - The ID of the school
 * @param {string} startDate - Inclusive ISO timestamp
 * @param {string} endDate - Exclusive ISO timestamp
 * Frontend contract: startDate is inclusive and endDate is exclusive.
 * Server enforcement is outside this client repository.
 */
export function getSchoolAssessmentsByDateRange(schoolId, startDate, endDate) {
  return instance
    .get(`/schools/${schoolId}/assessments/bydaterange`, {
      params: {
        startDate,
        endDate
      }
    })
    .then(response => {
      // Check the shape of the response and log it
      console.log("API Raw Response:", response);
      return response.data || []; // Ensure we return an array
    })
    .catch(error => {
      console.error("Error fetching school assessments:", error);
      return []; // Return empty array on error
    });
}


/**
 * Fetch all classes for a school
 * @param {string} schoolId - The ID of the school
 * @returns {Promise<any[]>} - Promise resolving to the list of classes for the school
 */
export function getClassesBySchoolId(schoolId) {
  return instance
    .get(`/schools/${schoolId}/classes`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching classes for school:", error);
      throw error;
    });
}

/**
 * Fetch all classes for a school
 * @param {string} teacherId - The ID of the school
 * @returns {Promise<any[]>} - Promise resolving to the list of classes for the school
 */
export function getClassesByTeacherId(teacherId) {
  return instance
    .get(`/teachers/${teacherId}/classes`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching classes for teacher:", error);
      throw error;
    });
}

export function getClassesAssessmentResults(classIds, assessmentId) {
  return instance
    .post("/classes/assessments/results/v4", {
      classIds: classIds,
      assessmentId: assessmentId,
    })
    .then((response) => {
      console.log(response);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching class assessment results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

// export function getClassesAssessmentResults(classIds, assessmentId) {
//   return instance
//     .post("/classes/assessments/results/v2", {
//       classIds: classIds,
//       assessmentId: assessmentId,
//     })
//     .then((response) => {
//       console.log(response);
//       return response.data;
//     })
//     .catch((error) => {
//       // Handle any errors here
//       console.error("Error fetching class assessment results:", error);
//       throw error; // or return an error message, depending on your error handling strategy
//     });
// }

/**
 * Fetch all classes for a school
 * @param {string} schoolId - The ID of the school
 * @returns {Promise<any[]>} - Promise resolving to the list of classes for the school
 */
export function getClassesByAssessmentId(
  assessmentId,
  schoolId,
  timeframe = null
) {
  let url = `/schools/${schoolId}/classes/by-assessment/${assessmentId}/v2`;

  // `end` is the exclusive upper bound of the requested date range.
  if (timeframe) {
    url += `?start=${timeframe.start}&end=${timeframe.end}`;
  }

  return instance
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching classes for assessment:", error);
      throw error;
    });
}

// /**
//  * Fetch all classes for a school
//  * @param {string} schoolId - The ID of the school
//  * @returns {Promise<any[]>} - Promise resolving to the list of classes for the school
//  */
// export function getClassesByAssessmentId(
//   assessmentId,
//   schoolId,
//   timeframe = null
// ) {
//   let url = `/schools/${schoolId}/classes/by-assessment/${assessmentId}/v2`;

//   // Add timeframe as query parameters if provided
//   if (timeframe) {
//     url += `?start=${timeframe.start}&end=${timeframe.end}`;
//   }

//   return instance
//     .get(url)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       console.error("Error fetching classes for assessment:", error);
//       throw error;
//     });
// }

/**
 *
 * @param {*} studentId
 * @param {*} classId
 * @returns
 */
export function addAdditionalClass(studentId, classId) {
  return instance
    .post(`students/${studentId}/additional-classes`, { classId })
    .then((response) => {
      return response.data; // Return the created StudentClass object
    })
    .catch((error) => {
      console.error("Error adding additional class:", error);
      throw error; // Propagate the error for further handling
    });
}

/**
 * Posts a new ScoreHeatMap record based on the provided data.
 * @param {Object} scoreHeatMapData - The JSON data for the ScoreHeatMap.
 * @returns {Promise}
 */
export function createScoreHeatMap(scoreHeatMapData) {
  return instance
    .post("/score-heat-maps", scoreHeatMapData)
    .then((response) => {
      console.log("Create ScoreHeatMap Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating ScoreHeatMap:", error);
      throw error;
    });
}

/**
 * Deletes an additional class entry for a student.
 * @param {string} studentId - The ID of the student.
 * @param {string} classId - The ID of the additional class to delete.
 * @returns {Promise<void>} - A promise that resolves when the deletion is successful.
 */
export function deleteAdditionalClass(studentId, classId) {
  return instance
    .delete(`students/${studentId}/additional-classes/${classId}`)
    .then((response) => {
      return response.data; // You may not need to return data, but can log it if necessary
    })
    .catch((error) => {
      console.error("Error deleting additional class:", error);
      throw error; // Rethrow error to handle it in the calling code
    });
}

export function getAssessmentInstancesByStudentIds(studentIds) {
  return instance
    .post("assessment-instances/students", { studentIds }) // Send studentIds as part of the request body
    .then((response) => {
      return response.data; // Return the array of AssessmentInstance objects
    })
    .catch((error) => {
      console.error("Error fetching assessment instances:", error);
      throw error; // Propagate the error for further handling
    });
}

// Function to create a new RTI record
export const createRti = async (rtiData) => {
  console.log("Sending RTI data:", rtiData); // Log the data being sent

  return instance
    .post("/rti", rtiData)
    .then((response) => {
      console.log("RTI creation successful:", response); // Log the full response
      console.log("RTI data received:", response.data); // Log only the response data
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating RTI:", error); // Log error details
      console.log("rtiData", rtiData);
      if (error.response) {
        console.error("Error response data:", error.response.data); // Log error response data
        console.error("Error response status:", error.response.status); // Log error status code
        console.error("Error response headers:", error.response.headers); // Log error headers
      }
      throw error;
    });
};

export function getRtiRecords({ teacherid, studentid, taskid }) {
  // Build query parameters dynamically
  const params = new URLSearchParams();
  if (teacherid) params.append("teacherid", teacherid);
  if (studentid) params.append("studentid", studentid);
  if (taskid) params.append("taskid", taskid);

  // Make GET request with query parameters
  return instance
    .get(`/rti?${params.toString()}`)
    .then((response) => {
      console.log("Fetched RTI records:", response.data); // Log fetched data
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching RTI records:", error);
      throw error;
    });
}

export function assignCustomAssessment(
  selectStudentId,
  selectAssessmentId,
  selectAssessmentName
) {
  return instance
    .post(`/students/assessments`, {
      students: selectStudentId,
      assessment: {
        id: `${selectAssessmentId}`,
        name: `${selectAssessmentName}`,
      },
      isCustom: true, // Automatically set to true for custom assessments
    })
    .then((response) => {
      return response.data;
    });
}
/**
 * Retrieves tasks based on the specified grade level.
 *
 * @param {number} gradeLevel - The grade level to filter tasks by (1 or 2).
 * @returns {Promise} - Resolves to an array of tasks matching the grade level.
 */
export function getTasksByGradeLevel(gradeLevel) {
  return instance
    .get(`/tasks/grade-level/${gradeLevel}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(
        "Error retrieving tasks for grade level:",
        gradeLevel,
        error
      );
      throw error;
    });
}
/**
 * Creates a custom assessment
 *
 * @param {string} teacherId - The ID of the teacher creating the assessment
 * @param {string} name - The name of the assessment
 * @param {boolean} gradeLevel1 - Whether the assessment is for grade level 1
 * @param {boolean} gradeLevel2 - Whether the assessment is for grade level 2
 * @returns {Promise} - Resolves to the created custom assessment object
 */
export function createCustomAssessment(
  teacherId,
  name,
  gradeLevel1,
  gradeLevel2
) {
  return instance
    .post(`/custom-assessments`, {
      teacherid: teacherId,
      name: name,
      grade_level1: gradeLevel1,
      grade_level2: gradeLevel2,
    })
    .then((response) => {
      return response.data;
    });
}
/**
 * Retrieves custom assessments for a specific teacher
 *
 * @param {string} teacherId - The ID of the teacher
 * @returns {Promise} - Resolves to an array of custom assessments for the teacher
 */
export function getCustomAssessments(teacherId) {
  return instance
    .get(`/custom-assessments/${teacherId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(
        "Error retrieving custom assessments for teacher:",
        teacherId,
        error
      );
      throw error;
    });
}
/**
 * Adds steps to a custom assessment
 *
 * @param {string} customAssessmentId - The ID of the custom assessment
 * @param {Array} steps - Array of step objects, each containing a taskid and order
 * @returns {Promise} - Resolves to an array of created custom assessment steps
 */
export function createCustomAssessmentSteps(customAssessmentId, steps) {
  return instance
    .post(`/custom-assessment-steps/${customAssessmentId}`, steps)
    .then((response) => {
      return response.data;
    });
}
/**
 * Retrieves steps for a specific custom assessment
 *
 * @param {string} customAssessmentId - The ID of the custom assessment
 * @returns {Promise} - Resolves to an array of steps for the custom assessment
 */
export function getCustomAssessmentSteps(customAssessmentId) {
  return instance
    .get(`/custom-assessment-steps/${customAssessmentId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(
        "Error retrieving steps for custom assessment:",
        customAssessmentId,
        error
      );
      throw error;
    });
}

export function postAladdinExportAuditLog(
  teacherid,
  schoolId,
  assessmentName,
  assessmentId,
  classids,
  classNames,
  exportType,
  academicYear
) {
  // Log the data being passed to the function
  console.log("Preparing to send request with the following data:");
  console.log("teacherid:", teacherid);
  console.log("schoolId:", schoolId);
  console.log("assessmentName:", assessmentName);
  console.log("assessmentId:", assessmentId);
  console.log("classids", classids);
  console.log("classNames", classNames);

  return instance
    .post("/aladdinresultsexportauditlogs", {
      teacherid: teacherid,
      schoolId: schoolId,
      assessmentName: assessmentName,
      assessmentId: assessmentId,
      classids: classids,
      classNames: classNames,
      exportType: exportType,
      academicYear: academicYear,
    })
    .then((response) => {
      // Log the response data
      console.log("Received response:", response.data);
      return response.data;
    })
    .catch((error) => {
      // Handle any errors here
      console.error("Error fetching student results:", error);
      throw error; // or return an error message, depending on your error handling strategy
    });
}

export function sendAladdinResultsEmail(
  teacherEmail,
  teacherName,
  emailPayload
) {
  console.log("📨 Requesting email send with payload:", emailPayload);

  return instance
    .post("/send-aladdin-results-email", {
      teacherEmail,
      teacherName,
      ...emailPayload, // Spread the already prepared payload (processed data)
    })
    .then((response) => {
      console.log("✅ Email request sent successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("❌ Error sending email:", error);
      throw error;
    });
}

/**
 * Add a student to the watchlist with initial note
 * @param {Object} data - { studentid, teacherid, note }
 * @returns {Promise} - The response from the API
 */
export function addStudentToWatchlist(data) {
  return instance
    .post("/sen-watchlist", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error adding student to watchlist", error);
      throw error;
    });
}

/**
 * Get all watchlist entries
 * @param {boolean} includeRemoved - Whether to include removed students (default: false)
 * @returns {Promise} - The response from the API
 */
export function getWatchlist(includeRemoved = false) {
  return instance
    .get("/sen-watchlist", {
      params: { includeRemoved },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching watchlist", error);
      throw error;
    });
}

/**
 * Get a single watchlist entry by studentId
 * @param {string} studentId - The ID of the student
 * @returns {Promise} - The response from the API
 */
export function getWatchlistByStudent(studentId) {
  return instance
    .get(`/sen-watchlist/${studentId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching watchlist entry", error);
      throw error;
    });
}

/**
 * Remove a student from the watchlist (soft delete)
 * @param {string} studentId - The ID of the student
 * @param {Object} data - { teacherid, note }
 * @returns {Promise} - The response from the API
 */
export function removeStudentFromWatchlist(studentId, data) {
  return instance
    .put(`/sen-watchlist/${studentId}/remove`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error removing student from watchlist", error);
      throw error;
    });
}

/**
 * Remove a student from the watchlist (soft delete)
 * @param {string} studentId - The ID of the student
 * @param {Object} data - { teacherid, note }
 * @returns {Promise} - The response from the API
 */
export function deleteWatchlistStudent(studentId, data) {
  return instance
    .put(`/sen-watchlist/${studentId}/remove`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error removing student from watchlist", error);
      throw error;
    });
}

/**
 * Add a general note to a student's watchlist entry
 * @param {string} studentId - The ID of the student
 * @param {Object} data - { teacherid, note }
 * @returns {Promise} - The response from the API
 */
export function addWatchlistNote(studentId, data) {
  return instance
    .post(`/sen-watchlist/${studentId}/notes`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error adding note to watchlist", error);
      throw error;
    });
}

/**
 * Get all notes for a student's watchlist entry
 * @param {string} studentId - The ID of the student
 * @param {boolean} includeDeleted - Whether to include deleted notes (default: false)
 * @returns {Promise} - The response from the API
 */
export function getWatchlistNotes(studentId, includeDeleted = false) {
  return instance
    .get(`/sen-watchlist/${studentId}/notes`, {
      params: { includeDeleted },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching watchlist notes", error);
      throw error;
    });
}

/**
 * Soft delete a note from the watchlist
 * @param {string} noteId - The ID of the note
 * @param {Object} data - { teacherid }
 * @returns {Promise} - The response from the API
 */
export function deleteWatchlistNote(noteId, data) {
  return instance
    .delete(`/sen-watchlist/notes/${noteId}`, { data })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting watchlist note", error);
      throw error;
    });
}

/**
 * Send email notifications for a watchlist note
 * @param {Object} data - { teacherids: string[], senwatchlistid, senwatchlistnoteid }
 * @returns {Promise} - The response from the API
 */
export function sendWatchlistNotifications(data) {
  return instance
    .post("/sen-watchlist/notify", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error sending watchlist notifications", error);
      throw error;
    });
}

/**
 * Get watchlist students for a school
 * @param {string} schoolid - The school ID
 * @param {boolean} includeRemoved - Whether to include removed students
 * @returns {Promise} - The response from the API
 */
export function getWatchlistStudents(schoolid, includeRemoved = false) {
  return instance
    .get("/sen-watchlist/students", {
      params: { schoolid, includeRemoved },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching watchlist students", error);
      throw error;
    });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getSenStudents(schoolid) {
  return instance.get(`/schools/${schoolid}/students/sen`).then((response) => {
    return response.data;
  });
}

/**
 *
 * @param {*} studentid
 * @returns
 */
export function getStudentClassDetail(studentId) {
  return instance.get(`/students/${studentId}/class`).then((response) => {
    return response.data;
  });
}

/**
 * Create a new assessment reminder
 *
 * @param reminderData - Object containing reminder information
 * @param reminderData.assessmentid - ID of the assessment to be reminded about
 * @param reminderData.assessmentName - Name of the assessment (e.g., "Jnr End of Year Assessment")
 * @param reminderData.academicYear - Academic year in format "YY/YY" (e.g., "24/25")
 * @param reminderData.email - (Optional) Override email address to send notifications to
 * @param reminderData.name - (Optional) Override teacher name for the notification
 *
 * @returns Promise with the created reminder data
 *
 * @example
 * // Basic usage with required fields only
 * createAssessmentReminder({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   assessmentName: 'Jnr End of Year Assessment',
 *   academicYear: '24/25'
 * });
 *
 * // With custom email and name
 * createAssessmentReminder({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   assessmentName: 'Jnr End of Year Assessment',
 *   academicYear: '24/25',
 *   email: 'custom@example.com',
 *   name: 'Custom Teacher Name'
 * });
 */
export const createAssessmentReminder = async (reminderData) => {
  try {
    const response = await instance.post("/assessment-reminders", reminderData);
    console.log("reminderData", reminderData);
    return response.data;
  } catch (error) {
    console.error("Error creating assessment reminder:", error);
    throw error;
  }
};

/**
 * Get all reminders for the currently authenticated teacher
 *
 * @returns Promise with an array of reminder objects
 *
 * @example
 * // Get all reminders for the current user
 * const myReminders = await getTeacherReminders();
 */
export const getTeacherReminders = async () => {
  try {
    const response = await instance.get("/assessment-reminders");
    return response.data;
  } catch (error) {
    console.error("Error fetching teacher reminders:", error);
    throw error;
  }
};

/**
 * Get a specific reminder by ID
 *
 * @param reminderId - ID of the reminder to retrieve
 * @returns Promise with the reminder object
 *
 * @example
 * // Get a specific reminder
 * const reminder = await getAssessmentReminder('123e4567-e89b-12d3-a456-426614174000');
 */
export const getAssessmentReminder = async (reminderId) => {
  try {
    const response = await instance.get(`/assessment-reminders/${reminderId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching reminder with ID ${reminderId}:`, error);
    throw error;
  }
};

/**
 * Delete a specific reminder
 *
 * @param reminderId - ID of the reminder to delete
 * @returns Promise resolving when deletion is complete
 *
 * @example
 * // Delete a specific reminder
 * await deleteAssessmentReminder('123e4567-e89b-12d3-a456-426614174000');
 */
export const deleteAssessmentReminder = async (reminderId) => {
  try {
    await instance.delete(`/assessment-reminders/${reminderId}`);
    return true;
  } catch (error) {
    console.error(`Error deleting reminder with ID ${reminderId}:`, error);
    throw error;
  }
};

/**
 * Get count of reminders matching specific criteria (admin function)
 *
 * @param where - Filter criteria in Loopback format
 * @returns Promise with the count of matching reminders
 *
 * @example
 * // Count all pending reminders for a specific assessment
 * const count = await countAssessmentReminders({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   notificationSent: false
 * });
 */
export const countAssessmentReminders = async (where = {}) => {
  try {
    // Serialize where object for URL params
    const params = Object.keys(where).length
      ? { where: JSON.stringify(where) }
      : {};
    const response = await instance.get("/assessment-reminders/count", {
      params,
    });
    return response.data.count;
  } catch (error) {
    console.error("Error counting assessment reminders:", error);
    throw error;
  }
};

/**
 * Mark assessment results as ready and send notifications (admin function)
 * Triggers emails to all teachers who requested reminders for this assessment
 *
 * @param notifyData - Object containing notification parameters
 * @param notifyData.assessmentid - ID of the assessment that's now ready
 * @param notifyData.academicYear - Academic year in format "YY/YY" (e.g., "24/25")
 * @returns Promise with the notification results (count of total and sent)
 *
 * @example
 * // Mark End of Year assessment results as ready for 24/25
 * const result = await markAssessmentResultsReady({
 *   assessmentid: 'd613e45e-b3b0-4d0f-bcdc-cc17f38bd285',
 *   academicYear: '24/25'
 * });
 * // Result: { message: "Sent 15 of 15 notifications", total: 15, sent: 15 }
 */
export const markAssessmentResultsReady = async (notifyData) => {
  try {
    const response = await instance.post(
      "/admin/assessment-reminders/notify",
      notifyData
    );
    return response.data;
  } catch (error) {
    console.error("Error marking assessment results as ready:", error);
    throw error;
  }
};

// export async function getTeachersBySchoolId(schoolid) {
//   try {
//     const response = await instance.get(`/schools/${schoolid}/teachers/csd`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching teachers for school:", error);
//     throw error; // Ensure error is propagated for error handling
//   }
// }

export async function getTeachersBySchoolIdCheck(schoolid) {
  try {
    const response = await instance.get(`/schools/${schoolid}/teachers/check`);
    return response.data;
  } catch (error) {
    console.error("Error fetching teachers for school:", error);
    throw error; // Ensure error is propagated for error handling
  }
}


export function shareResults(recipientId, senderName, sharePayload) {
  console.log("📨 Requesting results share with payload:", sharePayload);

  return instance
    .post("/share-results", {
      recipientId,
      senderName,
      ...sharePayload, // Spread the already prepared payload (processed data)
    })
    .then((response) => {
      console.log("✅ Results share request sent successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("❌ Error sharing results:", error);
      throw error;
    });
}

/**
 * Shares student assessment reports with specified recipients
 *
 * @param {string} teacherId - ID of the teacher sharing the report
 * @param {string} schoolId - ID of the school
 * @param {string} assessmentId - ID of the assessment
 * @param {string} assessmentName - Name of the assessment
 * @param {string[]} studentIds - Array of student IDs to include in the report
 * @param {string[]} recipientEmails - Array of email addresses to send the report to
 * @param {boolean} isDetailedView - Whether to generate a detailed or basic report
 * @returns {Promise} - Promise that resolves to the API response
 */
export function shareReport(
  teacherId,
  schoolId,
  assessmentIds,
  studentIds,
  recipientTeacherIds,
  isDetailedView
) {
  return instance
    .post("/share-report", {
      teacherid: teacherId,
      schoolId: schoolId,
      assessmentIds: assessmentIds,
      studentIds: studentIds,
      recipientTeacherIds: recipientTeacherIds,
      isDetailedView: isDetailedView,
    })
    .then((response) => {
      return response.data;
    });
}


/**
 * Get performance overview for a single class for a specific assessment
 * 
 * @param {string} classId - UUID of the class
 * @param {string} assessmentId - UUID of the assessment
 * @param {object} timeframe - Optional date range filter
 * @param {string} timeframe.start - Start date (YYYY-MM-DD)
 * @param {string} timeframe.end - End date (YYYY-MM-DD)
 * @returns {Promise} Response with single class performance data
 */
export function getClassPerformanceOverview(schoolId, assessmentId, timeframe = null) {
  const payload = {
    schoolId,
    assessmentId,
    ...(timeframe && { timeframe })
  };

  console.log("Payload for class performance overview:", payload);

  return instance
    .post("/classes/assessment/performance-overview", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching class performance overview:", error);
      throw error;
    });
}

/**
 * Get progress overview for a single class across multiple assessment points
 * Replaces the old ScreenerPieCharts component's multiple API calls
 *
 * @param {string} schoolId - UUID of the school
 * @param {string} classId - UUID of the class
 * @param {boolean} isJunior - Optional: true for junior, false for senior (determines default assessment IDs)
 * @param {object} assessmentIds - Optional: specific assessment IDs to use
 * @param {string} assessmentIds.baseline - UUID of baseline assessment
 * @param {string} assessmentIds.midpoint - UUID of midpoint assessment
 * @param {string} assessmentIds.endOfYear - UUID of end of year assessment
 * @returns {Promise} Response with className and assessmentPoints data
 */
export function getClassProgressOverview(schoolId, classId, gradeLevel = null, assessmentIds = null) {
  const payload = {
    schoolId,
    classId,
    ...(gradeLevel && { gradeLevel }),
    ...(assessmentIds && { assessmentIds })
  };

  console.log("getClassProgressOverview payload:", payload);

  return instance
    .post("/classes/assessment/progress-overview", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching class progress overview:", error);
      throw error;
    });
}



/**
 * Get screener assessment IDs grouped by grade level for a school.
 * Returns baseline/midpoint/endOfYear assessment UUIDs for each grade level
 * available to the school's country, classified by assessment name.
 *
 * @param {string} schoolId - UUID of the school
 * @returns {Promise<Record<string, {baseline?: string, midpoint?: string, endOfYear?: string}>>}
 *   Object keyed by grade level number string ("1", "2", "3", "4").
 *   Returns empty object if school has no country or no matching assessments.
 */
export function getScreenerAssessmentIds(schoolId) {
  return instance
    .get(`/schools/${schoolId}/screener-assessment-ids`)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error fetching screener assessment IDs:', error);
      throw error;
    });
}

/**
 * Get all country-level screener settings for a school
 *
 * @param {string} schoolid - School ID to get country screeners for
 * @returns Array of CountryScreener objects with windowStatus, available, and windowConfigured
 */
export function getCountryScreeners(schoolid) {
  return instance.get(`/countryscreeners/by-school/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Get all country-level screener settings by country ID
 * 
 * @param {string} countryid - Country ID to get screeners for
 * @returns Array of CountryScreener objects with windowStatus, available, and windowConfigured
 */
export function getCountryScreenersByCountryId(countryid) {
  return instance.get(`/countryscreeners/by-country/${countryid}`).then((response) => {
    return response.data;
  });
}

export function getMyTrialScreenerAccess() {
  return instance
    .get('/trial-screener-access/me')
    .then((response) => response.data);
}

/**
 * Get all school-level screener settings for a school
 * 
 * @param {string} schoolid - School ID to get screeners for
 * @returns Array of SchoolScreener objects with windowStatus, available, and windowConfigured
 */
export function getSchoolScreeners(schoolid) {
  return instance.get(`/schoolscreeners/by-school/${schoolid}`).then((response) => {
    return response.data;
  });
}

/**
 * Submit class number confirmation for a school
 *
 * @param {Object} classNumberData - The class number confirmation data
 * @param {string} classNumberData.teacherid - Teacher ID
 * @param {string} classNumberData.schoolid - School ID  
 * @param {number} [classNumberData.grade_level1_class_numbers] - Grade 1 class count
 * @param {number} [classNumberData.grade_level2_class_numbers] - Grade 2 class count
 * @param {number} [classNumberData.grade_level3_class_numbers] - Grade 3 class count
 * @param {number} [classNumberData.grade_level4_class_numbers] - Grade 4 class count
 * @returns {Promise} Created class number confirmation with matched_entry status
 */
export function submitClassNumberConfirmation(classNumberData) {
  console.log('API client sending data:', JSON.stringify(classNumberData, null, 2));

  return instance
    .post("/classnumberconfirmations", classNumberData)
    .then((response) => {
      console.log('API client received response:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('API client error:', error.message);
      console.error('API client error response:', error.response?.data);
      throw error;
    });
}

/**
 * Check if a school already has confirmed class numbers for current academic year
 *
 * @param {string} schoolid - School ID to check
 * @returns {Promise} Object with hasConfirmation, academicYear, and confirmedEntry
 */
export function checkSchoolConfirmation(schoolid) {
  return instance
    .get(`/classnumberconfirmations/check-confirmation/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all class number confirmations with optional filtering
 *
 * @param {Object} [filter] - LoopBack filter object
 * @returns {Promise} Array of class number confirmations
 */
export function getClassNumberConfirmations(filter = {}) {
  const params = Object.keys(filter).length > 0 ? { filter: JSON.stringify(filter) } : {};

  return instance
    .get("/classnumberconfirmations", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get class number confirmations by academic year
 *
 * @param {string} academicYear - Academic year (e.g., "25-26")
 * @returns {Promise} Array of class number confirmations for the academic year
 */
export function getConfirmationsByAcademicYear(academicYear) {
  return instance
    .get(`/classnumberconfirmations/by-academic-year/${academicYear}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get class number confirmations by teacher
 *
 * @param {string} teacherid - Teacher ID
 * @returns {Promise} Array of class number confirmations by the teacher
 */
export function getConfirmationsByTeacher(teacherid) {
  return instance
    .get(`/classnumberconfirmations/by-teacher/${teacherid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get class number confirmations by school
 *
 * @param {string} schoolid - School ID
 * @returns {Promise} Array of class number confirmations for the school
 */
export function getConfirmationsBySchool(schoolid) {
  return instance
    .get(`/classnumberconfirmations/by-school/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get class number confirmations by school and academic year
 *
 * @param {string} schoolid - School ID
 * @param {string} academicYear - Academic year (e.g., "25-26")
 * @returns {Promise} Array of class number confirmations for the school and year
 */
export function getConfirmationsBySchoolAndYear(schoolid, academicYear) {
  return instance
    .get(`/classnumberconfirmations/by-school-year/${schoolid}/${academicYear}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get a specific class number confirmation by ID
 *
 * @param {string} id - Confirmation ID
 * @returns {Promise} Class number confirmation object
 */
export function getClassNumberConfirmationById(id) {
  return instance
    .get(`/classnumberconfirmations/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of class number confirmations with optional filtering
 *
 * @param {Object} [where] - Where clause for filtering
 * @returns {Promise} Count object
 */
export function getClassNumberConfirmationCount(where = {}) {
  const params = Object.keys(where).length > 0 ? { where: JSON.stringify(where) } : {};

  return instance
    .get("/classnumberconfirmations/count", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Check if a teacher has already submitted class numbers for the current academic year
 * 
 * @param {string} teacherid - The ID of the teacher
 * @param {string} schoolid - The ID of the school
 * @returns {Promise} Response with hasSubmitted, academicYear, and submission data
 */
export function hasTeacherSubmittedClassNumbers(teacherid, schoolid) {
  return instance
    .get(`/classnumberconfirmations/has-teacher-submitted/${teacherid}/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new class conversion method
 *
 * @param {string} teacherid 
 * @param {string} schoolid 
 * @param {string} transition_type 
 * @returns Created ClassConversionMethod object
 */
export function createClassConversionMethod(teacherid, schoolid, transition_type) {
  return instance
    .post("/classconversionmethods", {
      teacherid,
      schoolid,
      transition_type
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all class conversion methods
 *
 * @param {object} filter - Optional filter parameters
 * @returns Array of ClassConversionMethod objects
 */
export function getClassConversionMethods(filter) {
  const params = filter ? { filter: JSON.stringify(filter) } : {};

  return instance
    .get("/classconversionmethods", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all available transitioned classes for a school that can be claimed by teachers
 *
 * @param {string} schoolId - The ID of the school
 * @param {number|string} progression - A numeric legacy grade or durable progression key
 * @param {string} academicYear - The academic year in format YY-YY (e.g., "25-26")
 * @returns Promise that resolves to available classes data
 */
export function getAvailableTransitionedClasses(schoolId, progression, academicYear) {
  const progressionMatch = typeof progression === "string"
    ? progression.match(/^grade(\d+)$/)
    : null;
  const gradeLevel = typeof progression === "number"
    ? progression
    : progressionMatch
      ? Number(progressionMatch[1])
      : undefined;

  return instance
    .get(`/schools/${schoolId}/available-classes`, {
      params: {
        academicYear: academicYear,
        ...(gradeLevel !== undefined ? { grade_level: gradeLevel } : {}),
        ...(typeof progression === "string"
          ? { progressionKey: progression }
          : {}),
      }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Read the server-authoritative Classroom Handover entry state. This wrapper
 * returns response.data, like the other data-oriented API helpers in this file.
 */
export function getClassroomHandoverEntry(schoolId, academicYear) {
  return instance
    .get(`/schools/${schoolId}/classroom-handover/entry`, {
      params: { academicYear },
    })
    .then((response) => response.data);
}

/** Read the authoritative Classroom Transition entry/progress state. */
export function getClassroomTransitionPreflight({ schoolId, targetAcademicYear, source, launchId }) {
  return instance
    .get("/teachers/me/classroom-transitions/preflight", {
      params: {
        schoolId,
        targetAcademicYear,
        ...(source ? { source } : {}),
        ...(launchId ? { launchId } : {}),
      },
    })
    .then((response) => response.data);
}

/** Read the children still awaiting resolution for a completed class level. */
// fallow-ignore-next-line unused-export -- consumed by the dynamically loaded handover adapter.
export function getClassroomTransitionReconciliation(schoolId, targetAcademicYear, progressionPointId) {
  return instance
    .get(
      `/schools/${schoolId}/classroom-transitions/${targetAcademicYear}/progression-points/${progressionPointId}/reconciliation`
    )
    .then((response) => response.data);
}

/** Persist the selected transition points and their positive classroom counts. */
export function saveClassroomTransitionScope(
  schoolId,
  targetAcademicYear,
  progressionPoints,
  expectedScopeVersion
) {
  return instance
    .put(
      `/schools/${schoolId}/classroom-transitions/${targetAcademicYear}/scope`,
      { progressionPoints, ...(expectedScopeVersion !== undefined ? { expectedScopeVersion } : {}) }
    )
    .then((response) => response.data);
}

/** Issue a short-lived, single-use code for the authenticated TCSD handoff. */
export function issueClassroomTransitionHandoff(schoolId, targetAcademicYear) {
  return instance
    .post(
      `/schools/${schoolId}/classroom-transitions/${targetAcademicYear}/handoffs`,
      { source: "td" }
    )
    .then((response) => response.data);
}

/** Submit a typed Different Groupings teacher nomination for the shared transition. */
export function submitClassroomTransitionTeacherNomination(
  schoolId,
  targetAcademicYear,
  { fullName, position, schoolEmail }
) {
  return instance
    .post(
      `/schools/${schoolId}/classroom-transitions/${targetAcademicYear}/nominations`,
      { fullName, position, schoolEmail }
    )
    .then((response) => response.data);
}

const classroomHandoverIdempotencyConfig = (idempotencyKey) => ({
  headers: { "Idempotency-Key": idempotencyKey },
});

/**
 * Persist the school/year grouping decision. The idempotency key is supplied
 * by the focused handover hook so a retry replays the exact same request.
 */
export function saveClassroomHandoverGroupingDecision(
  schoolId,
  { academicYear, progressionKey, decision, expectedVersion, idempotencyKey }
) {
  return instance
    .post(
      `/schools/${schoolId}/classroom-handover/grouping-decision`,
      { academicYear, progressionKey, decision, expectedVersion },
      classroomHandoverIdempotencyConfig(idempotencyKey)
    )
    .then((response) => response.data);
}

export function getClassroomHandoverClasses(
  schoolId,
  { academicYear, progressionKey }
) {
  return instance
    .get(`/schools/${schoolId}/classroom-handover/classes`, {
      params: { academicYear, progressionKey },
    })
    .then((response) => response.data);
}

/**
 * Load the reload-safe class/teacher setup draft. Handover setup endpoints
 * derive the acting user from authentication; schoolId and classId only scope
 * the target resource.
 */
export function getClassroomHandoverSetup(schoolId, classId) {
  return instance
    .get(`/schools/${schoolId}/classroom-handover/classes/${classId}/setup`)
    .then((response) => response.data);
}

export function continueClassroomHandoverSetup(
  schoolId,
  classId,
  {
    className,
    teacherId = null,
    pendingTeacherId = null,
    expectedVersion,
    idempotencyKey,
  }
) {
  return instance
    .post(
      `/schools/${schoolId}/classroom-handover/classes/${classId}/setup/continue`,
      { className, teacherId, pendingTeacherId, expectedVersion },
      classroomHandoverIdempotencyConfig(idempotencyKey)
    )
    .then((response) => response.data);
}

/**
 * Read the server-authoritative roster used by the final handover review.
 * This deliberately has no fixture or local fallback: child data is only
 * meaningful when it comes from the protected handover resource.
 */
export function getClassroomHandoverChildren(schoolId, classId) {
  return instance
    .get(`/schools/${schoolId}/classroom-handover/classes/${classId}/children`)
    .then((response) => response.data);
}

/**
 * Atomically apply the staged child change-set and finish classroom setup.
 * Keeping the idempotency key in a header matches the existing handover
 * writes and allows a client to replay an unknown outcome safely.
 */
export function finishClassroomHandoverSetup(
  schoolId,
  classId,
  { expectedVersion, changes, idempotencyKey }
) {
  return instance
    .post(
      `/schools/${schoolId}/classroom-handover/classes/${classId}/finish`,
      { expectedVersion, changes },
      classroomHandoverIdempotencyConfig(idempotencyKey)
    )
    .then((response) => response.data);
}

export function searchClassroomHandoverTeachers(schoolId, search) {
  return instance
    .get(`/schools/${schoolId}/teacher-account-lookup`, {
      params: { search, limit: 20, offset: 0 },
    })
    .then((response) => response.data);
}

export function inviteClassroomHandoverTeacher(schoolId, { name, email }) {
  const nameParts = name.trim().split(/\s+/);
  const firstName = nameParts.shift() || "";
  const lastName = nameParts.join(" ");

  return instance
    .post(`/schools/${schoolId}/teacher-invites/batch`, {
      users: [{ firstName, lastName, email: email.trim().toLowerCase() }],
    })
    .then((response) => response.data);
}

/**
 * Check if a teacher has a claimed class (is class owner) for a specific grade and academic year
 *
 * @param {string} schoolId - The ID of the school
 * @param {string} teacherId - The ID of the teacher to check
 * @param {string} academicYear - The academic year in format YY-YY (e.g., "25-26")
 * @param {number} gradeLevel - The grade level to filter by (1, 2, 3, etc.)
 * @returns Promise that resolves to teacher class ownership status
 */
export function checkTeacherHasClaimedClass(schoolId, teacherId, academicYear, gradeLevel) {
  return instance
    .get(`/schools/${schoolId}/teacher-has-class`, {
      params: {
        teacherId: teacherId,
        grade_level: gradeLevel,
        academicYear: academicYear
      }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Remove or replace the class owner
 * @param {string} classId - ID of the class
 * @param {string|null} newClassOwnerId - New owner ID, or null/empty to remove the current owner
 * @returns {Promise}
 */
export function removeOrReplaceClassOwner(classId, newClassOwnerId) {
  console.log(`Attempting to ${newClassOwnerId ? 'replace' : 'remove'} class owner for class ${classId}`);

  return instance.patch(`/classes/${classId}/owner`, { newClassOwnerId })
    .then(response => {
      if (newClassOwnerId) {
        console.log(`Successfully replaced class owner for class ${classId} with ${newClassOwnerId}`);
      } else {
        console.log(`Successfully removed class owner for class ${classId}`);
      }
      return response;
    })
    .catch(error => {
      console.error(`Error ${newClassOwnerId ? 'replacing' : 'removing'} class owner for class ${classId}.`, error);
      throw error;
    });
}


/**
 * Add a new student to a class
 * @param {Object} studentData - Student data object
 * @param {string} studentData.name - Student name
 * @param {string} studentData.classid - ID of the class to add the student to
 * @param {string} studentData.gradeLevel - Grade level of the student
 * @returns {Promise} - API response
 */
export const addStudent = async (studentData) => {
  try {
    const response = await instance.post("/students", studentData);
    return response.data;
  } catch (error) {
    console.error("Error adding student:", error);
    throw error;
  }
};

/**
 * Get a list of all students in a class with additional details
 * This is an extended version of getStudents that includes more student details
 * @param {string} classId - The ID of the class
 * @returns {Promise} - API response with students data
 */
export const getClassStudentsWithDetails = async (classId) => {
  try {
    const response = await instance.get(`/classes/${classId}/students/details`);
    return response.data;
  } catch (error) {
    console.error("Error fetching students with details:", error);
    throw error;
  }
};

/**
 * Update multiple students at once (batch update)
 * @param {Array} studentsData - Array of student objects with updates
 * @returns {Promise} - API response
 */
export const updateMultipleStudents = async (studentsData) => {
  try {
    const response = await instance.put("/students/batch", { students: studentsData });
    return response.data;
  } catch (error) {
    console.error("Error updating multiple students:", error);
    throw error;
  }
};

/**
 * Move students between classes
 * @param {Array} studentIds - Array of student IDs to move
 * @param {string} sourceClassId - ID of the source class
 * @param {string} targetClassId - ID of the target class
 * @returns {Promise} - API response
 */
export const moveStudentsBetweenClasses = async (studentIds, sourceClassId, targetClassId) => {
  try {
    const response = await instance.post("/students/move", {
      studentIds,
      sourceClassId,
      targetClassId
    });
    return response.data;
  } catch (error) {
    console.error("Error moving students between classes:", error);
    throw error;
  }
};

export async function batchDeleteStudents(data) {
  console.log("🔥 batchDeleteStudents FUNCTION CALLED");
  console.log("📥 Received data:", JSON.stringify(data, null, 2));
  console.log("📥 Data types:", {
    studentIds: typeof data.studentIds,
    studentIdsLength: data.studentIds?.length,
    deletionReason: typeof data.deletionReason,
    deletedByTeacherId: typeof data.deletedByTeacherId,
    deletedByTeacherName: typeof data.deletedByTeacherName
  });

  try {
    console.log("🌐 Making DELETE request to /students/batch");
    const response = await instance.delete('/students/batch', {
      data: {
        studentIds: data.studentIds,
        deletionReason: data.deletionReason,
        deletedByTeacherId: data.deletedByTeacherId,
        deletedByTeacherName: data.deletedByTeacherName
      }
    });

    console.log("✅ DELETE request successful");
    console.log("📤 Response:", response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error in batchDeleteStudents function:', error);
    throw error;
  }
}

// /**
//  * Create a new schoolmis record
//  *
//  * @param {string} teacherid
//  * @param {string} schoolid  
//  * @param {string} mis_system
//  * @returns Promise with the created schoolmis record
//  */
// export function createSchoolmis(teacherid, schoolid, mis_system) {
//   return instance
//     .post("/schoolmis", {
//       teacherid: teacherid,
//       schoolid: schoolid,
//       mis_system: mis_system,
//     })
//     .then((response) => {
//       return response.data;
//     });
// }

// /**
//  * Get a single schoolmis record by ID
//  *
//  * @param {string} schoolid
//  * @returns Promise with the schoolmis record
//  */
// export function getSchoolmisRecordById(schoolid) {
//   return instance
//     .get(`/schoolmis/school/${schoolid}`)
//     .then((response) => {
//       return response.data;
//     });
// }

/**
 * Create a Schoolmis record
 * POST /schoolmis
 *
 * @param {{ teacherid: string, schoolid: string, mis_system: string }} payload
 * @returns {Promise<any>} created Schoolmis entity
 */
export function createSchoolmis(payload) {
  return instance.post("/schoolmis", payload).then((res) => res.data);
}

/**
 * Get Schoolmis records for a specific school
 * GET /schoolmis/school/{schoolid}
 *
 * @param {string} schoolid
 * @returns {Promise<any[]>} array of Schoolmis entities
 */
export function getSchoolmisBySchoolId(schoolid) {
  return instance
    .get(`/schoolmis/school/${encodeURIComponent(schoolid)}`)
    .then((res) => res.data);
}

/**
 * Get assessments filtered by various criteria
 *
 * @param {Object} options - Filter options
 * @param {string} [options.countryid] - Country ID to filter by
 * @param {number} [options.grade_level] - Grade level (1, 2, etc.)
 * @param {boolean} [options.rti] - RTI flag
 * @param {boolean} [options.active] - Active flag (defaults to true on server)
 * @param {boolean} [options.standard] - Standard flag
 * @param {boolean} [options.task] - Task flag
 * @returns {Promise} Promise that resolves to array of filtered assessments
 */
export function getAssessmentScreener(options = {}) {
  // Build query parameters object, only including defined values
  const params = {};

  if (options.countryid !== undefined) {
    params.countryid = options.countryid;
  }

  if (options.grade_level !== undefined) {
    params.grade_level = options.grade_level;
  }

  if (options.rti !== undefined) {
    params.rti = options.rti;
  }

  if (options.active !== undefined) {
    params.active = options.active;
  }

  if (options.standard !== undefined) {
    params.standard = options.standard;
  }

  if (options.task !== undefined) {
    params.task = options.task;
  }

  return instance
    .get("/assessments/screener", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get screening window statuses by filters
 *
 * @param {Object} params - Query parameters (countryid, schoolid, active)
 * @returns Promise with array of screening window statuses
 */
export function getScreeningWindowStatuses(params = {}) {
  return instance
    .get("/screening-window-status", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get pilot by ID
 *
 * @param {string} id - Pilot ID
 * @returns Promise with pilot
 */
export function getPilotBySchoolId(schoolid) {
  return instance
    .get(`/pilots/school/${schoolid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get country ID for a specific school
 *
 * @param {string} schoolId - The ID of the school
 * @returns Promise that resolves to either {schoolId: string, countryId: string} or {message: string}
 */
export function getCountryId(schoolId) {
  return instance
    .get(`/schools/${schoolId}/country-id`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get unread in-platform messages for current user
 * 
 * @param {string} page - Optional page path to filter messages (e.g., "/dashboard")
 * @returns Promise with array of unread messages
 */
export function getUnreadMessages(page) {
  const params = page ? { page } : {};
  return instance
    .get("/in-platform-messages/unread", { params })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get count of unread messages
 * 
 * @returns Promise with count object
 */
export function getUnreadMessageCount() {
  return instance
    .get("/in-platform-messages/count")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all messages for current user
 * 
 * @returns Promise with array of all messages
 */
export function getAllMessages() {
  return instance
    .get("/in-platform-messages")
    .then((response) => {
      return response.data;
    });
}

/**
 * Mark a message as read
 * 
 * @param {string} messageId - ID of the message to mark as read
 * @returns Promise
 */
export function markMessageAsRead(messageId) {
  return instance
    .patch(`/in-platform-messages/${messageId}/read`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Dismiss a message (hide permanently)
 * 
 * @param {string} messageId - ID of the message to dismiss
 * @returns Promise
 */
export function dismissMessage(messageId) {
  return instance
    .patch(`/in-platform-messages/${messageId}/dismiss`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Mark all unread messages as read
 * 
 * @returns Promise with count of messages marked
 */
export function markAllMessagesAsRead() {
  return instance
    .patch("/in-platform-messages/mark-all-read")
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a manual test message (for testing/admin use)
 * 
 * @param {object} messageData - Message object
 * @returns Promise with created message
 */
export function createManualMessage(messageData) {
  return instance
    .post("/in-platform-messages/manual", messageData)
    .then((response) => {
      return response.data;
    });
}

/**
 * Delete a message
 * 
 * @param {string} messageId - ID of the message to delete
 * @returns Promise
 */
export function deleteMessage(messageId) {
  return instance
    .delete(`/in-platform-messages/${messageId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all active schools with GradeLevel3 feature access
 *
 * @returns Array of school IDs with active GradeLevel3 access
 */
export function getActiveGradeLevel3Schools() {
  return instance
    .get("/grade-level-3-feature-accesses/active-schools")
    .then((response) => {
      return response.data;
    });
}


/**
 * Get modal content for a country (for "Before Screening" modal)
 * @param {string} countryid - Country ID
 * @returns Array of folders with content cards
 */
export function getModalContentForCountry(countryid) {
  return instance
    .get("/sandbox-content/public", {
      params: {
        countryid: countryid,
        context: "modal",
      },
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get complete access information for a school (SUPER GET)
 * This returns trial status, purchase status, available grade levels, and expiry info
 * @param {string} schoolId - School ID
 * @param {string} academicYear - Optional academic year filter
 * @returns {Promise} Complete school access information
 */
export function getSchoolAccess(schoolId, academicYear = null) {
  const params = academicYear ? { academicYear } : {};
  return instance
    .get(`/school-access/${schoolId}`, { params })
    .then((response) => response.data);
}

/**
 * Get all available tag definitions
 *
 * @returns Array of all available features/tags
 */
export function getTagDefinitions() {
  return instance
    .get("/admin/features")
    .then((response) => {
      return response.data;
    });
}

/**
 * Get tags for an entity (school, country, teacher, etc)
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @returns Array of tags with current values for the entity
 */
export function getEntityTags(elementType, elementId) {
  return instance
    .get(`/admin/${elementType}/${elementId}/access`)
    .then((response) => {
      return response.data;
    });
}

export function getAladdinExportOptions(schoolId) {
  return instance
    .get(`/schools/${schoolId}/aladdin-export/options`)
    .then((response) => response.data);
}

export function getAladdinExportOptionClasses(schoolId, academicYear, assessmentId) {
  return instance
    .get(
      `/schools/${schoolId}/aladdin-export/options/${encodeURIComponent(academicYear)}/${assessmentId}/classes`
    )
    .then((response) => response.data);
}

export function getAladdinExportResults(schoolId, classIds, assessmentId, academicYear) {
  return instance
    .post(`/schools/${schoolId}/aladdin-export/results`, {
      classIds,
      assessmentId,
      academicYear,
    })
    .then((response) => response.data);
}

export function getResolvedTags(elementType, tagName, elementIds) {
  return instance
    .get("/admin/tags/resolved", {
      params: {
        elementType,
        tagName,
        elementIds: elementIds.join(","),
      },
    })
    .then((response) => response.data);
}

/**
 * Update tag value for an entity
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @param {string} tagDefinitionId - UUID of the tag definition
 * @param {string} tagValue - New value for the tag
 * @returns Updated tag object
 */
export function updateEntityTag(elementType, elementId, tagDefinitionId, tagValue) {
  return instance
    .patch(`/admin/${elementType}/${elementId}/features/${tagDefinitionId}`, {
      tag_value: tagValue,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Check if entity has access to a feature
 *
 * @param {string} elementType - Type of entity ("school", "country", "teacher")
 * @param {string} elementId - UUID of the entity
 * @param {string} tagName - Name of the tag/feature
 * @returns Boolean indicating access
 */
export function hasEntityAccess(elementType, elementId, tagName) {
  console.log('🔍 hasEntityAccess called with:', { elementType, elementId, tagName });

  return getEntityTags(elementType, elementId)
    .then((tags) => {
      console.log('📦 getEntityTags response:', tags);
      console.log('📦 All tags:', JSON.stringify(tags, null, 2));

      const tag = tags.find(t => {
        console.log('🔎 Checking tag:', t);
        console.log('🔎 tag_definition:', t.tag_definition);
        console.log('🔎 tag_definition.tag_name:', t.tag_definition?.tag_name);
        console.log('🔎 Match?', t.tag_definition?.tag_name === tagName);
        return t.tag_definition?.tag_name === tagName;
      });

      console.log('✅ Found matching tag:', tag);
      console.log('✅ Tag value:', tag?.tag_value);
      console.log('✅ Is ON?', tag?.tag_value === 'ON');

      return tag?.tag_value === 'ON';
    })
    .catch((err) => {
      console.error('❌ Error in hasEntityAccess:', err);
      throw err;
    });
}

/**
 * Check if standardised scores are enabled for an assessment
 *
 * @param {string} assessmentId - UUID of the assessment
 * @returns {Promise<boolean>} Boolean indicating if standardised scores are enabled
 */
export function checkStandardisedScoresEnabled(assessmentId) {
  return instance
    .get(`/assessments/${assessmentId}/standardised-scores-enabled`)
    .then((response) => {
      return response.data.enabled;
    })
    .catch((error) => {
      console.error('Error checking standardised scores status:', error);
      return false; // Fail closed - default to disabled
    });
}

/**
 * Get standardised scores tag details for an assessment
 *
 * @param {string} assessmentId - UUID of the assessment
 * @returns {Promise<{enabled: boolean, tagValue: string|null}>} Tag details
 */
export function getStandardisedScoresTag(assessmentId) {
  return instance
    .get(`/assessments/${assessmentId}/standardised-scores-tag`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error getting standardised scores tag:', error);
      return { enabled: false, tagValue: null };
    });
}


/**
 * Get next-year class creation configuration for a country
 * 
 * @param {string} countryId - Country UUID
 * @returns {Promise} Object with enabled (boolean) and availableYears (array)
 */
export function getNextYearClassConfig(countryId) {
  return instance
    .get(`/countries/${countryId}/next-year-class-config`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update next-year class creation configuration for a country
 * 
 * @param {string} countryId - Country UUID
 * @param {boolean} enabled - Whether feature is enabled
 * @param {string[]} availableYears - Array of academic years (e.g., ["25-26", "26-27"])
 * @returns {Promise} Updated config object
 */
export function updateNextYearClassConfig(countryId, enabled, availableYears) {
  return instance
    .patch(`/countries/${countryId}/next-year-class-config`, {
      enabled,
      availableYears,
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get next-year class creation eligibility for a school
 * 
 * @param {string} schoolId - School UUID
 * @returns {Promise} Eligibility details including payment status and transitioning classes
 */
export function getNextYearClassEligibility(schoolId) {
  return instance
    .get(`/schools/${schoolId}/next-year-class-eligibility`)
    .then((response) => {
      return response.data;
    });
}


/**
 *
 * @param {*} classid
 * @returns
 */
export function shareSenReport(teacherId, studentId, recipientEmails) {
  return instance
    .post("/share-sen-report", {
      teacherid: teacherId,
      studentid: studentId,
      recipientEmails: recipientEmails,
    })
    .then((response) => {
      return response.data;
    });
}

// JiSi-related endpoints copied and modified for Si-FC

/**
 * Upserts Si-FC report based on the provided data.
 * @param {Object} reportData - The JSON data for the Si-FC report.
 * @returns {Promise}
 */
export function upsertSiFcReport(reportData) {
  return instance
    .post("/si-fc-reports/upsert", reportData)
    .then((response) => {
      console.log("Upsert Si-FC Report Success:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error upserting Si-FC Report:", error);
      throw error;
    });
}

/**
 * Fetches a Si-FC Report based on student ID.
 * @param {string} studentId - The ID of the student to fetch the report for.
 * @returns {Promise}
 */
export function getSiFcReportByStudentId(studentId) {
  return instance
    .get(`/si-fc-reports/by-student/${studentId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching Si-FC Report by student ID:", error);
      throw error;
    });
}

export function getClassroomObservationsForClass(classId, academicYear, gradeLevel = 3) {
  return instance
    .get(`/classes/${classId}/classroom-observations`, {
      params: {academicYear, gradeLevel},
    })
    .then((response) => response.data);
}

export function getClassroomObservationByStudent(
  classId,
  studentId,
  academicYear,
  gradeLevel = 3
) {
  return instance
    .get(`/classes/${classId}/students/${studentId}/classroom-observation`, {
      params: {academicYear, gradeLevel},
    })
    .then((response) => response.data);
}

export function upsertClassroomObservation(
  classId,
  studentId,
  academicYear,
  reportData,
  gradeLevel = 3
) {
  const editableFieldNames = [
    "readingscorenotes",
    "literacyobservations",
    "additionalneeds",
    "supportplan",
    "eal",
    "set",
    "attendanceaffectingscores",
  ];
  const editableFields = Object.fromEntries(
    editableFieldNames
      .filter((field) => Object.prototype.hasOwnProperty.call(reportData, field))
      .map((field) => [field, reportData[field]])
  );
  return instance
    .patch(
      `/classes/${classId}/students/${studentId}/classroom-observation`,
      editableFields,
      {params: {academicYear, gradeLevel}}
    )
    .then((response) => response.data);
}

/**
 * Fetches a Si-FC Report based on class ID.
 * @param {string} classId - The ID of the class to fetch the report for.
 * @returns {Promise}
 */
export function getSiFcReportByClassId(classId) {
  return instance
    .get(`/si-fc-reports/by-class/${classId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching Si-FC Report by class ID:", error);
      throw error;
    });
}

// ==================== RECOMMENDATIONS ====================

/**
 * Get all recommendations with optional filters
 * @param {Object} filter - LoopBack filter object
 * @returns {Promise} Array of recommendations
 */
export function getAllRecommendations(filter = {}) {
  return instance
    .get("/recommendations", { params: filter })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendation by ID
 * @param {string} id - Recommendation ID
 * @returns {Promise} Recommendation object
 */
export function getRecommendationById(id) {
  return instance
    .get(`/recommendations/${id}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by task ID (individual task)
 * @param {string} taskid - Task ID
 * @returns {Promise} Array of recommendations
 */
export function getRecommendationsByTaskId(taskid) {
  return instance
    .get(`/recommendations/task/${taskid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by parent task ID (grouped tasks)
 * @param {string} parentTaskId - Parent Task ID
 * @returns {Promise} Array of recommendations
 */
export function getRecommendationsByParentTaskId(parentTaskId) {
  return instance
    .get(`/recommendations/parent/${parentTaskId}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get recommendations by assessment ID
 * @param {string} assessmentid - Assessment ID
 * @returns {Promise} Array of grouped recommendations by task
 */
export function getRecommendationsByAssessmentId(assessmentid) {
  return instance
    .get(`/recommendations/assessment/${assessmentid}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Create a new recommendation (admin only)
 * @param {Object} recommendation - Recommendation data
 * @returns {Promise} Created recommendation
 */
export function createRecommendation(recommendation) {
  return instance
    .post("/recommendations", recommendation)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update a recommendation by ID (admin only)
 * @param {string} id - Recommendation ID
 * @param {Object} recommendation - Updated recommendation data
 * @returns {Promise}
 */
export function updateRecommendation(id, recommendation) {
  return instance
    .patch(`/recommendations/${id}`, recommendation)
    .then((response) => {
      return response.data;
    });
}

/**
 * Update all recommendations for a parent task (admin only)
 * @param {string} parentTaskId - Parent Task ID
 * @param {Object} data - Updated recommendation data
 * @returns {Promise}
 */
export function updateRecommendationsByParentTaskId(parentTaskId, data) {
  return instance
    .patch(`/recommendations/parent/${parentTaskId}`, data)
    .then((response) => {
      return response.data;
    });
}

/**
 * Activate a recommendation (admin only)
 * @param {string} id - Recommendation ID
 * @param {string} userName - User making the change
 * @returns {Promise}
 */
export function activateRecommendation(id, userName) {
  return instance
    .patch(`/recommendations/${id}/activate`, null, {
      params: { updated_by: userName }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Deactivate a recommendation (admin only)
 * @param {string} id - Recommendation ID
 * @param {string} userName - User making the change
 * @returns {Promise}
 */
export function deactivateRecommendation(id, userName) {
  return instance
    .patch(`/recommendations/${id}/deactivate`, null, {
      params: { updated_by: userName }
    })
    .then((response) => {
      return response.data;
    });
}

/**
 * Get child tasks for a parent task (admin only)
 * @param {string} parentTaskId - Parent Task ID
 * @returns {Promise} Array of child tasks
 */
export function getChildTasksByParentId(parentTaskId) {
  return instance
    .get(`/recommendations/parent/${parentTaskId}/children`)
    .then((response) => {
      return response.data;
    });
}

// ==========================================
// BANNER CONTENT ENDPOINTS
// ==========================================

/**
 * Get banner content for a specific scenario type
 * Returns both definition and content
 * V1: Only fetches global defaults (no school/country specificity)
 * @param {string} scenarioType - e.g., 'trial_active', 'trial_expired', 'license_active', 'license_expired'
 * @returns {Promise} { definition: {...}, content: {...} }
 */
export const getBannerContentByScenario = (scenarioType) => {
  return instance.get(`/banner-contents/by-scenario/${scenarioType}`, {
    params: { locale: 'en-IE' }
  });
};

/**
 * Update banner content
 * @param {string} id - Content ID
 * @param {object} content - Updated content object
 * @returns {Promise}
 */
export const updateBannerContent = (id, content) => {
  return instance.patch(`/banner-contents/${id}`, content);
};

/**
 * Get all scenario definitions (for admin UI)
 * @returns {Promise} Array of scenario definitions
 */
export const getBannerScenarioDefinitions = () => {
  return instance.get('/banner-scenario-definitions', {
    params: {
      filter: JSON.stringify({ where: { is_active: true } })
    }
  });
};

/**
 * Get all banner content records (for admin UI)
 * @returns {Promise} Array of content records
 */
export const getAllBannerContent = () => {
  return instance.get('/banner-contents');
};




/**
 * Get notes for an element
 * @param {string} elementtype
 * @param {string} elementid
 * @param {string} [noteType] - Pass 'all' to skip type filtering
 * @param {boolean} [includeDeleted=false]
 */
export const getNotes = (elementtype, elementid, noteType, includeDeleted = false) => {
  return instance.get("/notes", {
    params: {
      elementtype,
      elementid,
      ...(noteType && { note_type: noteType }),
      includeDeleted,
    },
  });
};

/**
 * Create a note
 * @param {object} data
 * @param {string} data.elementtype
 * @param {string} data.elementid
 * @param {string} data.note_type
 * @param {'initial'|'removal'|'general'} data.type
 * @param {string} data.note_text
 * @param {string} data.teacherid
 */
export const createNote = (data) => {
  return instance.post("/notes", data);
};

/**
 * Soft delete a note
 * @param {string} noteid
 * @param {string} teacherid
 */
export const deleteNote = (noteid, teacherid) => {
  return instance.delete(`/notes/${noteid}`, {
    data: { teacherid },
  });
};

/**
 * Send email notifications about a note
 * @param {string[]} teacherids
 * @param {string} noteid
 */
export const sendNoteNotifications = (teacherids, noteid) => {
  return instance.post("/notes/notify", { teacherids, noteid });
};

/**
 * Get a specific active message by country and message_id slug
 * Falls back to a global message (no country) if no country-specific one is found
 *
 * @param {string} countryid
 * @param {string} message_id
 * @returns Message or null
 */
export function getMessageByMessageId(countryid, message_id) {
  return instance
    .get(`/messages/client/${countryid}/${message_id}`)
    .then((response) => {
      return response.data;
    });
}


/**
 * Check feature access for any entity type
 *
 * @param {string} elementType - e.g. 'teacher', 'school'
 * @param {string} elementId
 * @param {string} tagName - e.g. 'reports_enabled'
 * @returns {{ enabled: boolean }}
 */
export function checkFeatureAccess(elementType, elementId, tagName) {
  return instance
    .get(`/${elementType}/${elementId}/features/${tagName}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Check feature access for a teacher
 *
 * @param {string} teacherId
 * @param {string} tagName - e.g. 'reports_enabled'
 * @returns {{ enabled: boolean }}
 */
export function checkTeacherFeatureAccess(teacherId, tagName) {
  return instance
    .get(`/teachers/${teacherId}/features/${tagName}`)
    .then((response) => {
      return response.data;
    });
}

/**
 * Get all purchased entries for a specific school
 *
 * @param {string} schoolid - The school ID to filter purchases by
 * @param {object} filterOptions - Optional LoopBack filter parameters:
 *   @param {string} [filterOptions.order] - Sort order, e.g. "next_payment_date DESC" or "created_date ASC"
 *   @param {number} [filterOptions.limit] - Max number of records to return
 *   @param {number} [filterOptions.skip] - Number of records to skip (for pagination)
 *   @param {object} [filterOptions.where] - Additional filter conditions, e.g. { status: "active" }
 *   @param {object} [filterOptions.fields] - Fields to include/exclude in the response
 * @returns {Promise<Array>} Array of purchased entries for the school
 *
 * @example
 * DONAL - Below example for purchases endpoint. 
 * // Get all purchases sorted by next payment date (latest first)
 * getPurchasesBySchool("school123", { order: "next_payment_date DESC" })
 *
 * // Get active purchases only
 * getPurchasesBySchool("school123", { where: { status: "active" }, order: "next_payment_date DESC" })
 */
export function getPurchasesBySchool(schoolid, filterOptions = {}) {
  let url = `/purchased/school/${schoolid}`;

  // Add filter parameters as query string if provided
  // Remove the extra "filter" wrapper - LoopBack expects the filter object directly
  if (Object.keys(filterOptions).length > 0) {
    const filterParam = encodeURIComponent(JSON.stringify(filterOptions));
    url += `?filter=${filterParam}`;
  }

  return instance
    .get(url)
    .then((response) => {
      return response.data;
    });
}

/**
 * DONAL - Below GETS all banners by counry or school 
 * ALL BELOW DATA STORED IN TEST DB
 * Below psuedo is how I was thinking:
 * // On mount
purchased = getPurchasesBySchool(schoolid)
banners = getActiveBannerContents(countryid)
NOTE: schoolid does nothing. use countryid

// Find the countdown banner
countdownBanner = banners.find(b => b.scenario_type === 'banner_name_for_countdown') most likely renew_purchase or pilot_conversion

if (countdownBanner) {
  daysUntilPayment = purchased.next_payment_date - today
  
  if (daysUntilPayment <= countdownBanner.show_days_before) {
    show banner with countdownBanner.content
    display "X days remaining" using daysUntilPayment
  }
}
 */
export function getActiveBannerContents(schoolid, countryid) {
  const params = {};
  if (schoolid) params.schoolid = schoolid;
  if (countryid) params.countryid = countryid;

  return instance
    .get("/banner-contents/active", { params })
    .then((response) => {
      return response.data;
    });
}


export function getAllTaskRecommendations(...taskids) {
  let response = [];

  // taskids.forEach( id => {
  //   response.push( getRecommendations( id ) );
  // })

  const canned = [
    {
      id: 1,
      name: "Rhyming",
      // description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.Lorem ipsum dolor sit, amet consectetur adipisicing elit. At expedita fugit repellendus impedit dolorum pariatur molestiae perspiciatis velit amet odio quas quidem, debitis distinctio adipisci beatae et culpa ipsa quam.',
      // video: 'https://file-examples.com/storage/fe4658769b6331540b05587/2017/04/file_example_MP4_480_1_5MG.mp4',
      files: {
        all: "./docs/Alpaca_Rhyming_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 2,
      name: "Initial Phoneme",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Initial_Phoneme_Isolation_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 3,
      name: "Phoneme Blending",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Phoneme_Blending_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 4,
      name: "Letter Name Knowledge",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Letter_Name_Knowledge_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 5,
      name: "Phoneme Deletion",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Phoneme_Deletion_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 6,
      name: "Letter Sound Knowledge",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Letter_Sound_Knowledge_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 7,
      name: "Word Recognition",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Alpaca_Word_Recognition_Recommendations.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 8,
      name: "Letter Sound II",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/LetterSound-Midpoint.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 9,
      name: "Phonological Awareness - Midpoint",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Phonological Awareness-Midpoint.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 10,
      name: "Spelling - Midpoint",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Spelling-Midpoint.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 11,
      name: "Word Reading - Midpoint",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Word Reading-Midpoint.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 12,
      name: "Comprehension & Expressive Vocab - Midpoint",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Comprehension & Expressive Vocab-Midpoint.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 13,
      name: "Letter Sound III - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/LetterSound_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 14,
      name: "Phonological & Phonemic Awareness II - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/PhonologicalPhonemicAwareness_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 15,
      name: "Spelling II - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/Spelling_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 16,
      name: "Non Word Reading - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/NonWordReading_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 17,
      name: "Word Reading II - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/WordReading_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
    {
      id: 18,
      name: "Comprehension & Expressive Vocab - End of Year",
      // description: 'Description',
      // video: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      files: {
        all: "./docs/ListeningReadingComprehensionExpressiveVocabulary_EOY.pdf",
        // low: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // medium: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf',
        // high: 'https://www.smartcaptech.com/wp-content/uploads/sample.pdf'
      },
    },
  ];

  response = canned;

  return response;
}

export function getRecommendations(taskid) {
  return instance.get(`/tasks/${taskid}/recommendations`);
}

// =====================================================================
// APIClient.js — EOY REPORT ASSISTANT PATCH (v2)
// =====================================================================
//
// This REPLACES the earlier EOY patch you pasted in. Delete the old
// generateIndividualEOY / generateClassEOY / getEOYClasses exports from
// the bottom of APIClient.js, and paste THIS block in their place.
//
// submitEOYFeedback is updated to accept the new `reason` field.
// =====================================================================


/**
 * EOY Report Assistant backend.
 * Default local URL: http://localhost:8503
 */

/**
 * Generate one student's EOY report.
 * @param {{
 *   student_id: string,
 *   academicYear?: string,
 *   regenerate?: boolean,
 * }} payload
 */
export const generateIndividualEOYv2 = ({ student_id, academicYear, regenerate }) =>
  instance
    .post("eoy/individual", {
      studentId: student_id,
      academicYear,
      regenerate,
    })
    .then((res) => res.data);

/**
 * Generate EOY reports for a group of students.
 *
 * @param {{
 *   students: Array<{ student_id: string, display_name?: string }>,
 *   academicYear?: string,
 * }} payload
 */
export const generateClassEOYv2 = (payload) =>
  instance
    .post("eoy/batch", {
      students: payload.students || [],
      academicYear: payload.academicYear,
    })
    .then((res) => res.data);

/**
 * Get saved EOY reports for a list of students.
 * Current API shape:
 * POST /api/eoy/reports/class
 * { student_ids: string[], academicYear?: string }
 *
 * @param {string[]} studentIds
 * @param {string} academicYear
 */
export const getEOYClassReports = (studentIds, academicYear) =>
  instance
    .post("eoy/reports/class", { student_ids: studentIds, academicYear })
    .then((res) => res.data);

/**
 * Save a teacher-edited EOY report.
 *
 * @param {string} studentId
 * @param {string} reportText
 */
export const updateEOYReport = (studentId, reportText) =>
  instance
    .patch(`eoy/reports/${studentId}`, { report_text: reportText })
    .then((res) => res.data);

// =====================================================================
// ENHANCED AI REPORTS
// =====================================================================

/**
 * Generate one New Class Insights report.
 *
 * @param {{
 *   studentId: string,
 *   sourceAcademicYear?: string,
 *   destinationAcademicYear?: string,
 *   regenerate?: boolean,
 * }} payload
 */
export const generateIndividualNewClassInsights = (payload) =>
  instance
    .post("new-class-insights/individual", payload)
    .then((res) => res.data);

/**
 * Generate New Class Insights reports for a group of students.
 *
 * @param {{students: Array<{
 *   studentId: string,
 *   sourceAcademicYear?: string,
 *   destinationAcademicYear?: string,
 *   regenerate?: boolean,
 * }>}} payload
 */
export const generateBatchNewClassInsights = (payload) =>
  instance
    .post("new-class-insights/batch", payload)
    .then((res) => res.data);

/**
 * Get saved New Class Insights reports for a group of students.
 *
 * @param {{
 *   studentIds: string[],
 *   sourceAcademicYear?: string,
 *   destinationAcademicYear?: string,
 * }} payload
 */
export const getNewClassInsightsClassReports = (payload) =>
  instance
    .post("new-class-insights/reports/class", payload)
    .then((res) => res.data);

/**
 * Save a teacher-edited New Class Insights report.
 *
 * @param {string} studentId
 * @param {{
 *   reportText: string,
 *   sourceAcademicYear?: string,
 *   destinationAcademicYear?: string,
 * }} payload
 */
export const updateNewClassInsightsReport = (studentId, payload) =>
  instance
    .patch(`new-class-insights/reports/${studentId}`, payload)
    .then((res) => res.data);

/**
 * Generate one Screening Point report.
 *
 * @param {{
 *   studentId: string,
 *   screeningPoint: "baseline" | "midpoint" | "end_of_year",
 *   academicYear?: string,
 *   regenerate?: boolean,
 * }} payload
 */
export const generateIndividualScreeningPointReport = (payload) =>
  instance
    .post("screening-point-report/individual", payload)
    .then((res) => res.data);

/**
 * Generate Screening Point reports for a group of students.
 *
 * @param {{students: Array<{
 *   studentId: string,
 *   screeningPoint: "baseline" | "midpoint" | "end_of_year",
 *   academicYear?: string,
 *   regenerate?: boolean,
 * }>}} payload
 */
export const generateBatchScreeningPointReports = (payload) =>
  instance
    .post("screening-point-report/batch", payload)
    .then((res) => res.data);

/**
 * Get saved Screening Point reports for a group of students.
 *
 * @param {{
 *   studentIds: string[],
 *   screeningPoint: "baseline" | "midpoint" | "end_of_year",
 *   academicYear?: string,
 * }} payload
 */
export const getScreeningPointClassReports = (payload) =>
  instance
    .post("screening-point-report/reports/class", payload)
    .then((res) => res.data);

/**
 * Generate one Parent Teacher Meeting report.
 *
 * @param {{
 *   studentId: string,
 *   academicYear?: string,
 *   regenerate?: boolean,
 * }} payload
 */
export const generateIndividualPTMReport = (payload) =>
  instance.post("ptm-report/individual", payload).then((res) => res.data);

/**
 * Generate Parent Teacher Meeting reports for a group of students.
 *
 * @param {{students: Array<{
 *   studentId: string,
 *   academicYear?: string,
 *   regenerate?: boolean,
 * }>}} payload
 */
export const generateBatchPTMReports = (payload) =>
  instance.post("ptm-report/batch", payload).then((res) => res.data);

/**
 * Get saved Parent Teacher Meeting reports for a group of students.
 *
 * @param {{studentIds: string[], academicYear?: string}} payload
 */
export const getPTMClassReports = (payload) =>
  instance.post("ptm-report/reports/class", payload).then((res) => res.data);


/**
 * Submit feedback (thumbs up/down with optional free-text reason).
 *
 * @param {{
 *   student_id: string,
 *   report_text: string,
 *   rating: "up" | "down",
 *   reason?: string,      // required if rating is "down" (enforced in UI)
 *   class_id?: string,
 *   class_name?: string
 * }} payload
 */
export const submitEOYFeedback = (payload) =>
  instance.post("eoy/feedback", payload).then((res) => res.data);

// =====================================================================
// SENSAI chatbot endpoints
// =====================================================================

/**
 * Send a teacher message to SENSAI.
 *
 * @param {{
 *   message: string,
 *   teacher_id?: string,
 *   teacher_name?: string,
 *   school_id?: string,
 *   school_name?: string,
 *   country?: string,
 *   session_id?: string
 * }} payload
 */
export const sendSensaiMessage = (payload) =>
  sensaiInstance
    .post(sensaiEndpoint(), {
      message: payload.message,
      session_id: payload.session_id || null,
      teacher_id: payload.teacher_id || null,
      teacher_name: payload.teacher_name || null,
      school_id: payload.school_id || null,
      school_name: payload.school_name || null,
      country: payload.country || null,
    })
    .then((res) => res.data);

/**
 * Submit thumbs up/down feedback for a SENSAI response.
 *
 * @param {{
 *   reference?: string,
 *   reference_number?: string,
 *   rating: "up" | "down",
 *   reason?: string,
 *   comment?: string,
 *   message?: string,
 *   user_question?: string,
 *   reply?: string,
 *   ai_response?: string
 * }} payload
 */
export const submitSensaiFeedback = (payload) =>
  sensaiInstance
    .post(sensaiEndpoint("/feedback"), {
      reference: payload.reference || payload.reference_number || "",
      rating: payload.rating,
      reason: payload.reason || payload.comment || "",
      message: payload.message || payload.user_question || "",
      reply: payload.reply || payload.ai_response || "",
    })
    .then((res) => res.data);

/**
 * SENSAI chatbot health check.
 */
export const getSensaiHealth = () =>
  sensaiInstance.get(sensaiEndpoint("/health")).then((res) => res.data);
